import { Geodesic } from "geographiclib-geodesic";
import { VehicleGeolocated } from "./index";
import { Trips } from "../fleet/trips/tripsApi";

export const getDistanceInKm = (
  [lat1, lon1]: [number, number],
  [lat2, lon2]: [number, number],
) => {
  const geod = Geodesic.WGS84;
  const result = geod.Inverse(lat1, lon1, lat2, lon2);
  return (result.s12 ?? 0) / 1000; // result.s12 is in meters, we convert to km
};

export const fakeVehicleGeolocatedForDemo: VehicleGeolocated[] = [
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc3998bc",
    registrationNumber: "GE-123-OL",
    model: "CLIO",
    reference: "Geoloc 1",
    lastLatitude: 48.84091209,
    lastLongitude: 2.32097716,
    distance: 0,
    driverName: "John Doe",
    driverPhone: "07XXX45678",
    dataPoints: [
      {
        lat: 48.88669918,
        lon: 2.34308318,
        date: "2026-07-22T08:15:00.000Z",
      },
      {
        lat: 48.88659045,
        lon: 2.34293766,
        date: "2026-07-22T08:15:03.000Z",
      },
      {
        lat: 48.88654942,
        lon: 2.34279023,
        date: "2026-07-22T08:15:06.000Z",
      },
      {
        lat: 48.88648681,
        lon: 2.34258419,
        date: "2026-07-22T08:15:09.000Z",
      },
      {
        lat: 48.88636278,
        lon: 2.34247826,
        date: "2026-07-22T08:15:12.000Z",
      },
      {
        lat: 48.8862782,
        lon: 2.34226322,
        date: "2026-07-22T08:15:15.000Z",
      },
      {
        lat: 48.88624356,
        lon: 2.34213086,
        date: "2026-07-22T08:15:18.000Z",
      },
      {
        lat: 48.88615494,
        lon: 2.34196908,
        date: "2026-07-22T08:15:21.000Z",
      },
      {
        lat: 48.88603209,
        lon: 2.34177392,
        date: "2026-07-22T08:15:24.000Z",
      },
      {
        lat: 48.88597318,
        lon: 2.34166411,
        date: "2026-07-22T08:15:27.000Z",
      },
      {
        lat: 48.8859299,
        lon: 2.34144468,
        date: "2026-07-22T08:15:30.000Z",
      },
      {
        lat: 48.88581812,
        lon: 2.34132356,
        date: "2026-07-22T08:15:33.000Z",
      },
      {
        lat: 48.88571065,
        lon: 2.34114735,
        date: "2026-07-22T08:15:36.000Z",
      },
      {
        lat: 48.88567042,
        lon: 2.34096512,
        date: "2026-07-22T08:15:39.000Z",
      },
      {
        lat: 48.88560632,
        lon: 2.34084807,
        date: "2026-07-22T08:15:42.000Z",
      },
      {
        lat: 48.88548192,
        lon: 2.34062785,
        date: "2026-07-22T08:15:45.000Z",
      },
      {
        lat: 48.88539895,
        lon: 2.3405153,
        date: "2026-07-22T08:15:48.000Z",
      },
      {
        lat: 48.88536421,
        lon: 2.34032552,
        date: "2026-07-22T08:15:51.000Z",
      },
      {
        lat: 48.88527401,
        lon: 2.34015745,
        date: "2026-07-22T08:15:54.000Z",
      },
      {
        lat: 48.88515172,
        lon: 2.34003024,
        date: "2026-07-22T08:15:57.000Z",
      },
      {
        lat: 48.88509422,
        lon: 2.33981288,
        date: "2026-07-22T08:16:00.000Z",
      },
      {
        lat: 48.88504997,
        lon: 2.3397057,
        date: "2026-07-22T08:16:03.000Z",
      },
      {
        lat: 48.88493706,
        lon: 2.33950407,
        date: "2026-07-22T08:16:06.000Z",
      },
      {
        lat: 48.88483089,
        lon: 2.33935049,
        date: "2026-07-22T08:16:09.000Z",
      },
      {
        lat: 48.88479141,
        lon: 2.33921086,
        date: "2026-07-22T08:16:12.000Z",
      },
      {
        lat: 48.88472579,
        lon: 2.33899981,
        date: "2026-07-22T08:16:15.000Z",
      },
      {
        lat: 48.88460108,
        lon: 2.33889447,
        date: "2026-07-22T08:16:18.000Z",
      },
      {
        lat: 48.88451972,
        lon: 2.33868344,
        date: "2026-07-22T08:16:21.000Z",
      },
      {
        lat: 48.88448482,
        lon: 2.33854377,
        date: "2026-07-22T08:16:24.000Z",
      },
      {
        lat: 48.88439306,
        lon: 2.33839024,
        date: "2026-07-22T08:16:27.000Z",
      },
      {
        lat: 48.88427138,
        lon: 2.33818858,
        date: "2026-07-22T08:16:30.000Z",
      },
      {
        lat: 48.88421527,
        lon: 2.33808141,
        date: "2026-07-22T08:16:33.000Z",
      },
      {
        lat: 48.88417,
        lon: 2.33786405,
        date: "2026-07-22T08:16:36.000Z",
      },
      {
        lat: 48.884056,
        lon: 2.33773681,
        date: "2026-07-22T08:16:39.000Z",
      },
      {
        lat: 48.88395117,
        lon: 2.33756878,
        date: "2026-07-22T08:16:42.000Z",
      },
      {
        lat: 48.88391239,
        lon: 2.33737897,
        date: "2026-07-22T08:16:45.000Z",
      },
      {
        lat: 48.88370006,
        lon: 2.33749378,
        date: "2026-07-22T08:16:48.000Z",
      },
      {
        lat: 48.88353804,
        lon: 2.33758073,
        date: "2026-07-22T08:16:51.000Z",
      },
      {
        lat: 48.88340494,
        lon: 2.3376231,
        date: "2026-07-22T08:16:54.000Z",
      },
      {
        lat: 48.88322468,
        lon: 2.3376767,
        date: "2026-07-22T08:16:57.000Z",
      },
      {
        lat: 48.88301036,
        lon: 2.33777908,
        date: "2026-07-22T08:17:00.000Z",
      },
      {
        lat: 48.88283948,
        lon: 2.33788838,
        date: "2026-07-22T08:17:03.000Z",
      },
      {
        lat: 48.8827074,
        lon: 2.3379515,
        date: "2026-07-22T08:17:06.000Z",
      },
      {
        lat: 48.88253611,
        lon: 2.33799047,
        date: "2026-07-22T08:17:09.000Z",
      },
      {
        lat: 48.88232175,
        lon: 2.33806666,
        date: "2026-07-22T08:17:12.000Z",
      },
      {
        lat: 48.8821419,
        lon: 2.33818083,
        date: "2026-07-22T08:17:15.000Z",
      },
      {
        lat: 48.88200888,
        lon: 2.33827195,
        date: "2026-07-22T08:17:18.000Z",
      },
      {
        lat: 48.88184647,
        lon: 2.33831649,
        date: "2026-07-22T08:17:21.000Z",
      },
      {
        lat: 48.881634,
        lon: 2.33836674,
        date: "2026-07-22T08:17:24.000Z",
      },
      {
        lat: 48.88144549,
        lon: 2.3384657,
        date: "2026-07-22T08:17:27.000Z",
      },
      {
        lat: 48.88130962,
        lon: 2.33857708,
        date: "2026-07-22T08:17:30.000Z",
      },
      {
        lat: 48.88115556,
        lon: 2.33864439,
        date: "2026-07-22T08:17:33.000Z",
      },
      {
        lat: 48.88094686,
        lon: 2.33868285,
        date: "2026-07-22T08:17:36.000Z",
      },
      {
        lat: 48.8807504,
        lon: 2.33875465,
        date: "2026-07-22T08:17:39.000Z",
      },
      {
        lat: 48.88060991,
        lon: 2.3388677,
        date: "2026-07-22T08:17:42.000Z",
      },
      {
        lat: 48.88046329,
        lon: 2.3389628,
        date: "2026-07-22T08:17:45.000Z",
      },
      {
        lat: 48.88026003,
        lon: 2.33900994,
        date: "2026-07-22T08:17:48.000Z",
      },
      {
        lat: 48.88005671,
        lon: 2.33905718,
        date: "2026-07-22T08:17:51.000Z",
      },
      {
        lat: 48.87991004,
        lon: 2.33915242,
        date: "2026-07-22T08:17:54.000Z",
      },
      {
        lat: 48.87976959,
        lon: 2.33926542,
        date: "2026-07-22T08:17:57.000Z",
      },
      {
        lat: 48.87957319,
        lon: 2.33933705,
        date: "2026-07-22T08:18:00.000Z",
      },
      {
        lat: 48.87936445,
        lon: 2.3393755,
        date: "2026-07-22T08:18:03.000Z",
      },
      {
        lat: 48.87921033,
        lon: 2.33944297,
        date: "2026-07-22T08:18:06.000Z",
      },
      {
        lat: 48.87907449,
        lon: 2.33955443,
        date: "2026-07-22T08:18:09.000Z",
      },
      {
        lat: 48.87888604,
        lon: 2.33965325,
        date: "2026-07-22T08:18:12.000Z",
      },
      {
        lat: 48.87867356,
        lon: 2.33970338,
        date: "2026-07-22T08:18:15.000Z",
      },
      {
        lat: 48.8784721,
        lon: 2.33969149,
        date: "2026-07-22T08:18:18.000Z",
      },
      {
        lat: 48.87826421,
        lon: 2.33976035,
        date: "2026-07-22T08:18:21.000Z",
      },
      {
        lat: 48.87798211,
        lon: 2.33977157,
        date: "2026-07-22T08:18:24.000Z",
      },
      {
        lat: 48.87778552,
        lon: 2.33975002,
        date: "2026-07-22T08:18:27.000Z",
      },
      {
        lat: 48.87757201,
        lon: 2.33981338,
        date: "2026-07-22T08:18:30.000Z",
      },
      {
        lat: 48.87729102,
        lon: 2.33983885,
        date: "2026-07-22T08:18:33.000Z",
      },
      {
        lat: 48.87709887,
        lon: 2.33981093,
        date: "2026-07-22T08:18:36.000Z",
      },
      {
        lat: 48.87687953,
        lon: 2.33986535,
        date: "2026-07-22T08:18:39.000Z",
      },
      {
        lat: 48.87660032,
        lon: 2.33990462,
        date: "2026-07-22T08:18:42.000Z",
      },
      {
        lat: 48.8764121,
        lon: 2.33987416,
        date: "2026-07-22T08:18:45.000Z",
      },
      {
        lat: 48.87618679,
        lon: 2.33991688,
        date: "2026-07-22T08:18:48.000Z",
      },
      {
        lat: 48.87591002,
        lon: 2.33996843,
        date: "2026-07-22T08:18:51.000Z",
      },
      {
        lat: 48.87572517,
        lon: 2.33993945,
        date: "2026-07-22T08:18:54.000Z",
      },
      {
        lat: 48.87549382,
        lon: 2.33996867,
        date: "2026-07-22T08:18:57.000Z",
      },
      {
        lat: 48.8752201,
        lon: 2.34002997,
        date: "2026-07-22T08:19:00.000Z",
      },
      {
        lat: 48.87503804,
        lon: 2.34000638,
        date: "2026-07-22T08:19:03.000Z",
      },
      {
        lat: 48.87480067,
        lon: 2.34002136,
        date: "2026-07-22T08:19:06.000Z",
      },
      {
        lat: 48.87453059,
        lon: 2.34008913,
        date: "2026-07-22T08:19:09.000Z",
      },
      {
        lat: 48.87435067,
        lon: 2.34007439,
        date: "2026-07-22T08:19:12.000Z",
      },
      {
        lat: 48.87410738,
        lon: 2.34007554,
        date: "2026-07-22T08:19:15.000Z",
      },
      {
        lat: 48.87384146,
        lon: 2.34014597,
        date: "2026-07-22T08:19:18.000Z",
      },
      {
        lat: 48.87366303,
        lon: 2.34014285,
        date: "2026-07-22T08:19:21.000Z",
      },
      {
        lat: 48.873414,
        lon: 2.34013166,
        date: "2026-07-22T08:19:24.000Z",
      },
      {
        lat: 48.87315271,
        lon: 2.34020074,
        date: "2026-07-22T08:19:27.000Z",
      },
      {
        lat: 48.87297508,
        lon: 2.34021108,
        date: "2026-07-22T08:19:30.000Z",
      },
      {
        lat: 48.87272056,
        lon: 2.34019004,
        date: "2026-07-22T08:19:33.000Z",
      },
      {
        lat: 48.87246432,
        lon: 2.34025385,
        date: "2026-07-22T08:19:36.000Z",
      },
      {
        lat: 48.87228681,
        lon: 2.34027843,
        date: "2026-07-22T08:19:39.000Z",
      },
      {
        lat: 48.87202711,
        lon: 2.34025081,
        date: "2026-07-22T08:19:42.000Z",
      },
      {
        lat: 48.87177627,
        lon: 2.34030587,
        date: "2026-07-22T08:19:45.000Z",
      },
      {
        lat: 48.87157371,
        lon: 2.34059365,
        date: "2026-07-22T08:19:48.000Z",
      },
      {
        lat: 48.87138985,
        lon: 2.34081686,
        date: "2026-07-22T08:19:51.000Z",
      },
      {
        lat: 48.87121661,
        lon: 2.34113479,
        date: "2026-07-22T08:19:54.000Z",
      },
      {
        lat: 48.87103919,
        lon: 2.34140572,
        date: "2026-07-22T08:19:57.000Z",
      },
      {
        lat: 48.87084545,
        lon: 2.34163729,
        date: "2026-07-22T08:20:00.000Z",
      },
      {
        lat: 48.87063354,
        lon: 2.34196222,
        date: "2026-07-22T08:20:03.000Z",
      },
      {
        lat: 48.87041307,
        lon: 2.34221654,
        date: "2026-07-22T08:20:06.000Z",
      },
      {
        lat: 48.87019909,
        lon: 2.34246067,
        date: "2026-07-22T08:20:09.000Z",
      },
      {
        lat: 48.87000252,
        lon: 2.34278742,
        date: "2026-07-22T08:20:12.000Z",
      },
      {
        lat: 48.86982329,
        lon: 2.34302703,
        date: "2026-07-22T08:20:15.000Z",
      },
      {
        lat: 48.86965041,
        lon: 2.34328667,
        date: "2026-07-22T08:20:18.000Z",
      },
      {
        lat: 48.86946885,
        lon: 2.34360985,
        date: "2026-07-22T08:20:21.000Z",
      },
      {
        lat: 48.86926908,
        lon: 2.34383816,
        date: "2026-07-22T08:20:24.000Z",
      },
      {
        lat: 48.86905305,
        lon: 2.34411469,
        date: "2026-07-22T08:20:27.000Z",
      },
      {
        lat: 48.86883299,
        lon: 2.34442928,
        date: "2026-07-22T08:20:30.000Z",
      },
      {
        lat: 48.86862367,
        lon: 2.34465082,
        date: "2026-07-22T08:20:33.000Z",
      },
      {
        lat: 48.86843308,
        lon: 2.34494391,
        date: "2026-07-22T08:20:36.000Z",
      },
      {
        lat: 48.86825738,
        lon: 2.34524577,
        date: "2026-07-22T08:20:39.000Z",
      },
      {
        lat: 48.86808333,
        lon: 2.34546574,
        date: "2026-07-22T08:20:42.000Z",
      },
      {
        lat: 48.86789666,
        lon: 2.3457734,
        date: "2026-07-22T08:20:45.000Z",
      },
      {
        lat: 48.86769105,
        lon: 2.34605966,
        date: "2026-07-22T08:20:48.000Z",
      },
      {
        lat: 48.86747215,
        lon: 2.34628344,
        date: "2026-07-22T08:20:51.000Z",
      },
      {
        lat: 48.867254,
        lon: 2.34660222,
        date: "2026-07-22T08:20:54.000Z",
      },
      {
        lat: 48.86705016,
        lon: 2.34687157,
        date: "2026-07-22T08:20:57.000Z",
      },
      {
        lat: 48.86686516,
        lon: 2.34710415,
        date: "2026-07-22T08:21:00.000Z",
      },
      {
        lat: 48.86669163,
        lon: 2.34742947,
        date: "2026-07-22T08:21:03.000Z",
      },
      {
        lat: 48.86651497,
        lon: 2.34768232,
        date: "2026-07-22T08:21:06.000Z",
      },
      {
        lat: 48.86632255,
        lon: 2.3479278,
        date: "2026-07-22T08:21:09.000Z",
      },
      {
        lat: 48.86611168,
        lon: 2.34825443,
        date: "2026-07-22T08:21:12.000Z",
      },
      {
        lat: 48.86589133,
        lon: 2.34849283,
        date: "2026-07-22T08:21:15.000Z",
      },
      {
        lat: 48.86568334,
        lon: 2.34844264,
        date: "2026-07-22T08:21:18.000Z",
      },
      {
        lat: 48.86547345,
        lon: 2.34844986,
        date: "2026-07-22T08:21:21.000Z",
      },
      {
        lat: 48.86523321,
        lon: 2.34835832,
        date: "2026-07-22T08:21:24.000Z",
      },
      {
        lat: 48.86505325,
        lon: 2.34833847,
        date: "2026-07-22T08:21:27.000Z",
      },
      {
        lat: 48.86478767,
        lon: 2.34832367,
        date: "2026-07-22T08:21:30.000Z",
      },
      {
        lat: 48.86462653,
        lon: 2.34823058,
        date: "2026-07-22T08:21:33.000Z",
      },
      {
        lat: 48.86435008,
        lon: 2.34823479,
        date: "2026-07-22T08:21:36.000Z",
      },
      {
        lat: 48.86419103,
        lon: 2.34819009,
        date: "2026-07-22T08:21:39.000Z",
      },
      {
        lat: 48.86392144,
        lon: 2.34811202,
        date: "2026-07-22T08:21:42.000Z",
      },
      {
        lat: 48.86374711,
        lon: 2.34812649,
        date: "2026-07-22T08:21:45.000Z",
      },
      {
        lat: 48.86350005,
        lon: 2.34805335,
        date: "2026-07-22T08:21:48.000Z",
      },
      {
        lat: 48.86329765,
        lon: 2.34800221,
        date: "2026-07-22T08:21:51.000Z",
      },
      {
        lat: 48.86308206,
        lon: 2.34800991,
        date: "2026-07-22T08:21:54.000Z",
      },
      {
        lat: 48.86284718,
        lon: 2.34791869,
        date: "2026-07-22T08:21:57.000Z",
      },
      {
        lat: 48.8626626,
        lon: 2.34789794,
        date: "2026-07-22T08:22:00.000Z",
      },
      {
        lat: 48.86240055,
        lon: 2.34788399,
        date: "2026-07-22T08:22:03.000Z",
      },
      {
        lat: 48.86223724,
        lon: 2.34779069,
        date: "2026-07-22T08:22:06.000Z",
      },
      {
        lat: 48.86196144,
        lon: 2.34779433,
        date: "2026-07-22T08:22:09.000Z",
      },
      {
        lat: 48.86180332,
        lon: 2.34775058,
        date: "2026-07-22T08:22:12.000Z",
      },
      {
        lat: 48.86153129,
        lon: 2.34767184,
        date: "2026-07-22T08:22:15.000Z",
      },
      {
        lat: 48.86136071,
        lon: 2.34768623,
        date: "2026-07-22T08:22:18.000Z",
      },
      {
        lat: 48.86110886,
        lon: 2.34761387,
        date: "2026-07-22T08:22:21.000Z",
      },
      {
        lat: 48.86091192,
        lon: 2.34756178,
        date: "2026-07-22T08:22:24.000Z",
      },
      {
        lat: 48.86069062,
        lon: 2.34756995,
        date: "2026-07-22T08:22:27.000Z",
      },
      {
        lat: 48.86046127,
        lon: 2.34747907,
        date: "2026-07-22T08:22:30.000Z",
      },
      {
        lat: 48.86027177,
        lon: 2.34745742,
        date: "2026-07-22T08:22:33.000Z",
      },
      {
        lat: 48.86001366,
        lon: 2.34744431,
        date: "2026-07-22T08:22:36.000Z",
      },
      {
        lat: 48.85984769,
        lon: 2.34735081,
        date: "2026-07-22T08:22:39.000Z",
      },
      {
        lat: 48.85957307,
        lon: 2.34735386,
        date: "2026-07-22T08:22:42.000Z",
      },
      {
        lat: 48.85941534,
        lon: 2.34731108,
        date: "2026-07-22T08:22:45.000Z",
      },
      {
        lat: 48.85914137,
        lon: 2.34723166,
        date: "2026-07-22T08:22:48.000Z",
      },
      {
        lat: 48.85897413,
        lon: 2.34724597,
        date: "2026-07-22T08:22:51.000Z",
      },
      {
        lat: 48.85871781,
        lon: 2.34717439,
        date: "2026-07-22T08:22:54.000Z",
      },
      {
        lat: 48.85852614,
        lon: 2.34712136,
        date: "2026-07-22T08:22:57.000Z",
      },
      {
        lat: 48.85829917,
        lon: 2.34712997,
        date: "2026-07-22T08:23:00.000Z",
      },
      {
        lat: 48.8580963,
        lon: 2.34693261,
        date: "2026-07-22T08:23:03.000Z",
      },
      {
        lat: 48.8578154,
        lon: 2.3467977,
        date: "2026-07-22T08:23:06.000Z",
      },
      {
        lat: 48.85759568,
        lon: 2.34667991,
        date: "2026-07-22T08:23:09.000Z",
      },
      {
        lat: 48.85740419,
        lon: 2.34647709,
        date: "2026-07-22T08:23:12.000Z",
      },
      {
        lat: 48.85712855,
        lon: 2.34636927,
        date: "2026-07-22T08:23:15.000Z",
      },
      {
        lat: 48.85689316,
        lon: 2.3462212,
        date: "2026-07-22T08:23:18.000Z",
      },
      {
        lat: 48.85670917,
        lon: 2.34603121,
        date: "2026-07-22T08:23:21.000Z",
      },
      {
        lat: 48.8564431,
        lon: 2.34593676,
        date: "2026-07-22T08:23:24.000Z",
      },
      {
        lat: 48.85619243,
        lon: 2.34575824,
        date: "2026-07-22T08:23:27.000Z",
      },
      {
        lat: 48.8560113,
        lon: 2.34559504,
        date: "2026-07-22T08:23:30.000Z",
      },
      {
        lat: 48.85575818,
        lon: 2.34549571,
        date: "2026-07-22T08:23:33.000Z",
      },
      {
        lat: 48.8554941,
        lon: 2.34529683,
        date: "2026-07-22T08:23:36.000Z",
      },
      {
        lat: 48.85531094,
        lon: 2.34516536,
        date: "2026-07-22T08:23:39.000Z",
      },
      {
        lat: 48.85507287,
        lon: 2.34504454,
        date: "2026-07-22T08:23:42.000Z",
      },
      {
        lat: 48.85479858,
        lon: 2.34484227,
        date: "2026-07-22T08:23:45.000Z",
      },
      {
        lat: 48.85460868,
        lon: 2.34473676,
        date: "2026-07-22T08:23:48.000Z",
      },
      {
        lat: 48.85438632,
        lon: 2.3445851,
        date: "2026-07-22T08:23:51.000Z",
      },
      {
        lat: 48.85410598,
        lon: 2.34439754,
        date: "2026-07-22T08:23:54.000Z",
      },
      {
        lat: 48.85390529,
        lon: 2.34430347,
        date: "2026-07-22T08:23:57.000Z",
      },
      {
        lat: 48.85369775,
        lon: 2.34412202,
        date: "2026-07-22T08:24:00.000Z",
      },
      {
        lat: 48.85341615,
        lon: 2.34396231,
        date: "2026-07-22T08:24:03.000Z",
      },
      {
        lat: 48.85320166,
        lon: 2.34386131,
        date: "2026-07-22T08:24:06.000Z",
      },
      {
        lat: 48.85300662,
        lon: 2.34366114,
        date: "2026-07-22T08:24:09.000Z",
      },
      {
        lat: 48.85272863,
        lon: 2.34353304,
        date: "2026-07-22T08:24:12.000Z",
      },
      {
        lat: 48.85249871,
        lon: 2.34340907,
        date: "2026-07-22T08:24:15.000Z",
      },
      {
        lat: 48.85231262,
        lon: 2.34320759,
        date: "2026-07-22T08:24:18.000Z",
      },
      {
        lat: 48.85204279,
        lon: 2.34310419,
        date: "2026-07-22T08:24:21.000Z",
      },
      {
        lat: 48.85179727,
        lon: 2.34294895,
        date: "2026-07-22T08:24:24.000Z",
      },
      {
        lat: 48.85161571,
        lon: 2.342764,
        date: "2026-07-22T08:24:27.000Z",
      },
      {
        lat: 48.85135778,
        lon: 2.34267008,
        date: "2026-07-22T08:24:30.000Z",
      },
      {
        lat: 48.85109806,
        lon: 2.34248582,
        date: "2026-07-22T08:24:33.000Z",
      },
      {
        lat: 48.85091616,
        lon: 2.34232966,
        date: "2026-07-22T08:24:36.000Z",
      },
      {
        lat: 48.85067272,
        lon: 2.34222678,
        date: "2026-07-22T08:24:39.000Z",
      },
      {
        lat: 48.85040153,
        lon: 2.34202554,
        date: "2026-07-22T08:24:42.000Z",
      },
      {
        lat: 48.85021447,
        lon: 2.34190073,
        date: "2026-07-22T08:24:45.000Z",
      },
      {
        lat: 48.84997174,
        lon: 2.34166591,
        date: "2026-07-22T08:24:48.000Z",
      },
      {
        lat: 48.84977453,
        lon: 2.34147286,
        date: "2026-07-22T08:24:51.000Z",
      },
      {
        lat: 48.84961165,
        lon: 2.34120396,
        date: "2026-07-22T08:24:54.000Z",
      },
      {
        lat: 48.84940923,
        lon: 2.34103619,
        date: "2026-07-22T08:24:57.000Z",
      },
      {
        lat: 48.8491656,
        lon: 2.34075374,
        date: "2026-07-22T08:25:00.000Z",
      },
      {
        lat: 48.84895435,
        lon: 2.34058623,
        date: "2026-07-22T08:25:03.000Z",
      },
      {
        lat: 48.84878994,
        lon: 2.34031684,
        date: "2026-07-22T08:25:06.000Z",
      },
      {
        lat: 48.84860129,
        lon: 2.34012445,
        date: "2026-07-22T08:25:09.000Z",
      },
      {
        lat: 48.84836158,
        lon: 2.33988887,
        date: "2026-07-22T08:25:12.000Z",
      },
      {
        lat: 48.84813725,
        lon: 2.33965767,
        date: "2026-07-22T08:25:15.000Z",
      },
      {
        lat: 48.84796664,
        lon: 2.33946141,
        date: "2026-07-22T08:25:18.000Z",
      },
      {
        lat: 48.84778999,
        lon: 2.33919494,
        date: "2026-07-22T08:25:21.000Z",
      },
      {
        lat: 48.84755858,
        lon: 2.33902581,
        date: "2026-07-22T08:25:24.000Z",
      },
      {
        lat: 48.84732367,
        lon: 2.33874349,
        date: "2026-07-22T08:25:27.000Z",
      },
      {
        lat: 48.84714293,
        lon: 2.33857708,
        date: "2026-07-22T08:25:30.000Z",
      },
      {
        lat: 48.8469751,
        lon: 2.33830549,
        date: "2026-07-22T08:25:33.000Z",
      },
      {
        lat: 48.84675534,
        lon: 2.33811616,
        date: "2026-07-22T08:25:36.000Z",
      },
      {
        lat: 48.84651366,
        lon: 2.33787702,
        date: "2026-07-22T08:25:39.000Z",
      },
      {
        lat: 48.84632008,
        lon: 2.33764946,
        date: "2026-07-22T08:25:42.000Z",
      },
      {
        lat: 48.84615679,
        lon: 2.3374499,
        date: "2026-07-22T08:25:45.000Z",
      },
      {
        lat: 48.84595067,
        lon: 2.337186,
        date: "2026-07-22T08:25:48.000Z",
      },
      {
        lat: 48.8457068,
        lon: 2.33701531,
        date: "2026-07-22T08:25:51.000Z",
      },
      {
        lat: 48.84549921,
        lon: 2.33673336,
        date: "2026-07-22T08:25:54.000Z",
      },
      {
        lat: 48.84533568,
        lon: 2.33656783,
        date: "2026-07-22T08:25:57.000Z",
      },
      {
        lat: 48.84514351,
        lon: 2.33629421,
        date: "2026-07-22T08:26:00.000Z",
      },
      {
        lat: 48.84490232,
        lon: 2.33610781,
        date: "2026-07-22T08:26:03.000Z",
      },
      {
        lat: 48.84468124,
        lon: 2.33586518,
        date: "2026-07-22T08:26:06.000Z",
      },
      {
        lat: 48.84451268,
        lon: 2.33564127,
        date: "2026-07-22T08:26:09.000Z",
      },
      {
        lat: 48.84433314,
        lon: 2.33543832,
        date: "2026-07-22T08:26:12.000Z",
      },
      {
        lat: 48.84409917,
        lon: 2.33517716,
        date: "2026-07-22T08:26:15.000Z",
      },
      {
        lat: 48.84402198,
        lon: 2.33475305,
        date: "2026-07-22T08:26:18.000Z",
      },
      {
        lat: 48.84386899,
        lon: 2.33422456,
        date: "2026-07-22T08:26:21.000Z",
      },
      {
        lat: 48.84376277,
        lon: 2.33380991,
        date: "2026-07-22T08:26:24.000Z",
      },
      {
        lat: 48.84370214,
        lon: 2.33327693,
        date: "2026-07-22T08:26:27.000Z",
      },
      {
        lat: 48.84356529,
        lon: 2.3328616,
        date: "2026-07-22T08:26:30.000Z",
      },
      {
        lat: 48.84343208,
        lon: 2.33233444,
        date: "2026-07-22T08:26:33.000Z",
      },
      {
        lat: 48.84337275,
        lon: 2.3319084,
        date: "2026-07-22T08:26:36.000Z",
      },
      {
        lat: 48.84326204,
        lon: 2.33139637,
        date: "2026-07-22T08:26:39.000Z",
      },
      {
        lat: 48.84311065,
        lon: 2.33095145,
        date: "2026-07-22T08:26:42.000Z",
      },
      {
        lat: 48.84303692,
        lon: 2.33046124,
        date: "2026-07-22T08:26:45.000Z",
      },
      {
        lat: 48.8429537,
        lon: 2.32999251,
        date: "2026-07-22T08:26:48.000Z",
      },
      {
        lat: 48.84279895,
        lon: 2.32952704,
        date: "2026-07-22T08:26:51.000Z",
      },
      {
        lat: 48.8426999,
        lon: 2.32903372,
        date: "2026-07-22T08:26:54.000Z",
      },
      {
        lat: 48.84263639,
        lon: 2.32859163,
        date: "2026-07-22T08:26:57.000Z",
      },
      {
        lat: 48.84249423,
        lon: 2.32807716,
        date: "2026-07-22T08:27:00.000Z",
      },
      {
        lat: 48.84236733,
        lon: 2.32765305,
        date: "2026-07-22T08:27:03.000Z",
      },
      {
        lat: 48.84230923,
        lon: 2.32712456,
        date: "2026-07-22T08:27:06.000Z",
      },
      {
        lat: 48.84219142,
        lon: 2.32670991,
        date: "2026-07-22T08:27:09.000Z",
      },
      {
        lat: 48.84204339,
        lon: 2.32617693,
        date: "2026-07-22T08:27:12.000Z",
      },
      {
        lat: 48.84197459,
        lon: 2.3257616,
        date: "2026-07-22T08:27:15.000Z",
      },
      {
        lat: 48.84188483,
        lon: 2.32523444,
        date: "2026-07-22T08:27:18.000Z",
      },
      {
        lat: 48.84172937,
        lon: 2.3248084,
        date: "2026-07-22T08:27:21.000Z",
      },
      {
        lat: 48.84163732,
        lon: 2.32429637,
        date: "2026-07-22T08:27:24.000Z",
      },
      {
        lat: 48.84157,
        lon: 2.32385144,
        date: "2026-07-22T08:27:27.000Z",
      },
      {
        lat: 48.8414233,
        lon: 2.32336124,
        date: "2026-07-22T08:27:30.000Z",
      },
      {
        lat: 48.84130315,
        lon: 2.32289251,
        date: "2026-07-22T08:27:33.000Z",
      },
      {
        lat: 48.84124522,
        lon: 2.32242704,
        date: "2026-07-22T08:27:36.000Z",
      },
      {
        lat: 48.84112055,
        lon: 2.32193372,
        date: "2026-07-22T08:27:39.000Z",
      },
      {
        lat: 48.84097678,
        lon: 2.32149163,
        date: "2026-07-22T08:27:42.000Z",
      },
      {
        lat: 48.84091209,
        lon: 2.32097716,
        date: "2026-07-22T08:27:45.000Z",
      },
    ],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc399800",
    registrationNumber: "OC-444-AL",
    model: "DS",
    reference: "Geoloc 2",
    lastLatitude: 48.8270125,
    lastLongitude: 2.385118888888889,
    distance: 0,
    driverName: "John Smith",
    driverPhone: "07XXX34455",
    dataPoints: [
      {
        lat: 48.846743333333336,
        lon: 2.4144266666666665,
        date: "2025-06-10T10:13:46.000Z",
      },
      {
        lat: 48.846673888888894,
        lon: 2.4143544444444442,
        date: "2025-06-10T10:13:49.000Z",
      },
      {
        lat: 48.84657166666667,
        lon: 2.4143255555555556,
        date: "2025-06-10T10:13:52.000Z",
      },
      {
        lat: 48.846539166666666,
        lon: 2.4143202777777777,
        date: "2025-06-10T10:13:55.000Z",
      },
      {
        lat: 48.84650333333334,
        lon: 2.4143105555555553,
        date: "2025-06-10T10:13:58.000Z",
      },
      {
        lat: 48.846493333333335,
        lon: 2.414308333333333,
        date: "2025-06-10T10:14:01.000Z",
      },
      {
        lat: 48.846493333333335,
        lon: 2.414308333333333,
        date: "2025-06-10T10:14:04.000Z",
      },
      {
        lat: 48.846493333333335,
        lon: 2.414308333333333,
        date: "2025-06-10T10:14:07.000Z",
      },
      {
        lat: 48.84645861111111,
        lon: 2.414302777777778,
        date: "2025-06-10T10:14:10.000Z",
      },
      {
        lat: 48.846408611111116,
        lon: 2.4142916666666667,
        date: "2025-06-10T10:14:13.000Z",
      },
      {
        lat: 48.846383055555556,
        lon: 2.414286388888889,
        date: "2025-06-10T10:14:16.000Z",
      },
      {
        lat: 48.84634333333334,
        lon: 2.4142791666666668,
        date: "2025-06-10T10:14:19.000Z",
      },
      {
        lat: 48.84628777777778,
        lon: 2.414267777777778,
        date: "2025-06-10T10:14:22.000Z",
      },
      {
        lat: 48.84623638888889,
        lon: 2.414258611111111,
        date: "2025-06-10T10:14:25.000Z",
      },
      {
        lat: 48.846109444444444,
        lon: 2.4142333333333332,
        date: "2025-06-10T10:14:28.000Z",
      },
      {
        lat: 48.845983333333336,
        lon: 2.4142077777777775,
        date: "2025-06-10T10:14:31.000Z",
      },
      {
        lat: 48.84586,
        lon: 2.4141816666666664,
        date: "2025-06-10T10:14:34.000Z",
      },
      {
        lat: 48.84574027777778,
        lon: 2.414156111111111,
        date: "2025-06-10T10:14:37.000Z",
      },
      {
        lat: 48.845646388888895,
        lon: 2.4141355555555553,
        date: "2025-06-10T10:14:40.000Z",
      },
      {
        lat: 48.84555027777778,
        lon: 2.414115,
        date: "2025-06-10T10:14:43.000Z",
      },
      {
        lat: 48.84546277777778,
        lon: 2.414093888888889,
        date: "2025-06-10T10:14:46.000Z",
      },
      {
        lat: 48.84541111111111,
        lon: 2.414078611111111,
        date: "2025-06-10T10:14:49.000Z",
      },
      {
        lat: 48.84529083333334,
        lon: 2.414051111111111,
        date: "2025-06-10T10:14:52.000Z",
      },
      {
        lat: 48.84513555555556,
        lon: 2.4140194444444445,
        date: "2025-06-10T10:14:55.000Z",
      },
      {
        lat: 48.844994166666666,
        lon: 2.4139933333333334,
        date: "2025-06-10T10:14:58.000Z",
      },
      {
        lat: 48.84481888888889,
        lon: 2.4139577777777776,
        date: "2025-06-10T10:15:01.000Z",
      },
      {
        lat: 48.844678055555555,
        lon: 2.413929722222222,
        date: "2025-06-10T10:15:04.000Z",
      },
      {
        lat: 48.844616111111115,
        lon: 2.4139174999999997,
        date: "2025-06-10T10:15:07.000Z",
      },
      {
        lat: 48.84458138888889,
        lon: 2.4139097222222223,
        date: "2025-06-10T10:15:10.000Z",
      },
      {
        lat: 48.844545833333335,
        lon: 2.4139013888888887,
        date: "2025-06-10T10:15:13.000Z",
      },
      {
        lat: 48.844457222222225,
        lon: 2.413881111111111,
        date: "2025-06-10T10:15:16.000Z",
      },
      {
        lat: 48.84437888888889,
        lon: 2.413863888888889,
        date: "2025-06-10T10:15:19.000Z",
      },
      {
        lat: 48.84426305555556,
        lon: 2.4138430555555557,
        date: "2025-06-10T10:15:22.000Z",
      },
      {
        lat: 48.844123055555556,
        lon: 2.4138166666666665,
        date: "2025-06-10T10:15:25.000Z",
      },
      {
        lat: 48.84394638888889,
        lon: 2.4137775,
        date: "2025-06-10T10:15:28.000Z",
      },
      {
        lat: 48.84374666666667,
        lon: 2.4137408333333332,
        date: "2025-06-10T10:15:31.000Z",
      },
      {
        lat: 48.843538333333335,
        lon: 2.4137027777777775,
        date: "2025-06-10T10:15:34.000Z",
      },
      {
        lat: 48.84336916666667,
        lon: 2.4136744444444442,
        date: "2025-06-10T10:15:37.000Z",
      },
      {
        lat: 48.84321194444445,
        lon: 2.4136516666666665,
        date: "2025-06-10T10:15:40.000Z",
      },
      {
        lat: 48.843024166666666,
        lon: 2.413638888888889,
        date: "2025-06-10T10:15:43.000Z",
      },
      {
        lat: 48.84292277777778,
        lon: 2.4136277777777777,
        date: "2025-06-10T10:15:46.000Z",
      },
      {
        lat: 48.84268083333333,
        lon: 2.4136077777777776,
        date: "2025-06-10T10:15:49.000Z",
      },
      {
        lat: 48.84251305555556,
        lon: 2.413592222222222,
        date: "2025-06-10T10:15:52.000Z",
      },
      {
        lat: 48.84234194444445,
        lon: 2.4135763888888886,
        date: "2025-06-10T10:15:55.000Z",
      },
      {
        lat: 48.842198333333336,
        lon: 2.4135655555555555,
        date: "2025-06-10T10:15:58.000Z",
      },
      {
        lat: 48.842022500000006,
        lon: 2.4135508333333333,
        date: "2025-06-10T10:16:01.000Z",
      },
      {
        lat: 48.84187027777778,
        lon: 2.413539166666667,
        date: "2025-06-10T10:16:04.000Z",
      },
      {
        lat: 48.84176222222222,
        lon: 2.413530277777778,
        date: "2025-06-10T10:16:07.000Z",
      },
      {
        lat: 48.841656944444445,
        lon: 2.413524444444444,
        date: "2025-06-10T10:16:10.000Z",
      },
      {
        lat: 48.84157416666667,
        lon: 2.413517777777778,
        date: "2025-06-10T10:16:13.000Z",
      },
      {
        lat: 48.84148555555556,
        lon: 2.413509722222222,
        date: "2025-06-10T10:16:16.000Z",
      },
      {
        lat: 48.84139305555556,
        lon: 2.4135016666666664,
        date: "2025-06-10T10:16:19.000Z",
      },
      {
        lat: 48.84125027777778,
        lon: 2.4134877777777777,
        date: "2025-06-10T10:16:22.000Z",
      },
      {
        lat: 48.84113333333334,
        lon: 2.4134766666666665,
        date: "2025-06-10T10:16:25.000Z",
      },
      {
        lat: 48.84099694444445,
        lon: 2.4134675,
        date: "2025-06-10T10:16:28.000Z",
      },
      {
        lat: 48.840855000000005,
        lon: 2.4134547222222222,
        date: "2025-06-10T10:16:31.000Z",
      },
      {
        lat: 48.84070027777778,
        lon: 2.4134338888888887,
        date: "2025-06-10T10:16:34.000Z",
      },
      {
        lat: 48.84054444444445,
        lon: 2.4134124999999997,
        date: "2025-06-10T10:16:37.000Z",
      },
      {
        lat: 48.84039194444445,
        lon: 2.413386111111111,
        date: "2025-06-10T10:16:40.000Z",
      },
      {
        lat: 48.84018638888889,
        lon: 2.4133444444444443,
        date: "2025-06-10T10:16:43.000Z",
      },
      {
        lat: 48.83999055555556,
        lon: 2.4133002777777777,
        date: "2025-06-10T10:16:46.000Z",
      },
      {
        lat: 48.83985527777778,
        lon: 2.4132658333333334,
        date: "2025-06-10T10:16:49.000Z",
      },
      {
        lat: 48.839710833333335,
        lon: 2.4132255555555555,
        date: "2025-06-10T10:16:52.000Z",
      },
      {
        lat: 48.839580833333336,
        lon: 2.4131880555555556,
        date: "2025-06-10T10:16:55.000Z",
      },
      {
        lat: 48.839447500000006,
        lon: 2.4131477777777777,
        date: "2025-06-10T10:16:58.000Z",
      },
      {
        lat: 48.83930138888889,
        lon: 2.4131041666666664,
        date: "2025-06-10T10:17:01.000Z",
      },
      {
        lat: 48.83914444444445,
        lon: 2.4130577777777775,
        date: "2025-06-10T10:17:04.000Z",
      },
      {
        lat: 48.83898833333333,
        lon: 2.4130105555555557,
        date: "2025-06-10T10:17:07.000Z",
      },
      {
        lat: 48.83882916666667,
        lon: 2.412964166666667,
        date: "2025-06-10T10:17:10.000Z",
      },
      {
        lat: 48.838661388888895,
        lon: 2.412913611111111,
        date: "2025-06-10T10:17:13.000Z",
      },
      {
        lat: 48.83853444444445,
        lon: 2.4128766666666666,
        date: "2025-06-10T10:17:16.000Z",
      },
      {
        lat: 48.83837055555556,
        lon: 2.4128291666666666,
        date: "2025-06-10T10:17:19.000Z",
      },
      {
        lat: 48.83819527777778,
        lon: 2.4127722222222223,
        date: "2025-06-10T10:17:22.000Z",
      },
      {
        lat: 48.83797305555556,
        lon: 2.412706111111111,
        date: "2025-06-10T10:17:25.000Z",
      },
      {
        lat: 48.83774805555556,
        lon: 2.412634722222222,
        date: "2025-06-10T10:17:28.000Z",
      },
      {
        lat: 48.837542222222226,
        lon: 2.4125625,
        date: "2025-06-10T10:17:31.000Z",
      },
      {
        lat: 48.83733416666667,
        lon: 2.4124905555555554,
        date: "2025-06-10T10:17:34.000Z",
      },
      {
        lat: 48.837138611111115,
        lon: 2.4124263888888886,
        date: "2025-06-10T10:17:37.000Z",
      },
      {
        lat: 48.836955,
        lon: 2.412367777777778,
        date: "2025-06-10T10:17:40.000Z",
      },
      {
        lat: 48.83678777777778,
        lon: 2.4123127777777778,
        date: "2025-06-10T10:17:43.000Z",
      },
      {
        lat: 48.836626111111116,
        lon: 2.4122588888888887,
        date: "2025-06-10T10:17:46.000Z",
      },
      {
        lat: 48.836465555555556,
        lon: 2.4122049999999997,
        date: "2025-06-10T10:17:49.000Z",
      },
      {
        lat: 48.836309166666666,
        lon: 2.412146388888889,
        date: "2025-06-10T10:17:52.000Z",
      },
      {
        lat: 48.836150555555555,
        lon: 2.412068888888889,
        date: "2025-06-10T10:17:55.000Z",
      },
      {
        lat: 48.835935,
        lon: 2.4119105555555556,
        date: "2025-06-10T10:17:58.000Z",
      },
      {
        lat: 48.83558027777778,
        lon: 2.411586944444444,
        date: "2025-06-10T10:18:01.000Z",
      },
      {
        lat: 48.83513111111111,
        lon: 2.4110858333333334,
        date: "2025-06-10T10:18:04.000Z",
      },
      {
        lat: 48.83476888888889,
        lon: 2.4105608333333333,
        date: "2025-06-10T10:18:07.000Z",
      },
      {
        lat: 48.83457888888889,
        lon: 2.4102302777777775,
        date: "2025-06-10T10:18:10.000Z",
      },
      {
        lat: 48.83450777777778,
        lon: 2.410035277777778,
        date: "2025-06-10T10:18:13.000Z",
      },
      {
        lat: 48.83450638888889,
        lon: 2.410035277777778,
        date: "2025-06-10T10:18:16.000Z",
      },
      {
        lat: 48.83450638888889,
        lon: 2.410035277777778,
        date: "2025-06-10T10:18:19.000Z",
      },
      {
        lat: 48.83450638888889,
        lon: 2.410035277777778,
        date: "2025-06-10T10:18:22.000Z",
      },
      {
        lat: 48.834448333333334,
        lon: 2.40988,
        date: "2025-06-10T10:18:25.000Z",
      },
      {
        lat: 48.834476111111115,
        lon: 2.4097466666666665,
        date: "2025-06-10T10:18:28.000Z",
      },
      {
        lat: 48.834476111111115,
        lon: 2.4097466666666665,
        date: "2025-06-10T10:18:31.000Z",
      },
      {
        lat: 48.834476111111115,
        lon: 2.4097466666666665,
        date: "2025-06-10T10:18:34.000Z",
      },
      {
        lat: 48.83447833333334,
        lon: 2.409742222222222,
        date: "2025-06-10T10:18:37.000Z",
      },
      {
        lat: 48.83447666666667,
        lon: 2.409661388888889,
        date: "2025-06-10T10:18:40.000Z",
      },
      {
        lat: 48.83447833333334,
        lon: 2.409643611111111,
        date: "2025-06-10T10:18:43.000Z",
      },
      {
        lat: 48.83448194444445,
        lon: 2.4096402777777777,
        date: "2025-06-10T10:18:46.000Z",
      },
      {
        lat: 48.83449027777778,
        lon: 2.4096075,
        date: "2025-06-10T10:18:49.000Z",
      },
      {
        lat: 48.83452055555556,
        lon: 2.4095152777777775,
        date: "2025-06-10T10:18:52.000Z",
      },
      {
        lat: 48.834650833333335,
        lon: 2.4092130555555555,
        date: "2025-06-10T10:18:55.000Z",
      },
      {
        lat: 48.834811111111115,
        lon: 2.4087597222222223,
        date: "2025-06-10T10:18:58.000Z",
      },
      {
        lat: 48.83496777777778,
        lon: 2.4083775,
        date: "2025-06-10T10:19:01.000Z",
      },
      {
        lat: 48.835166111111114,
        lon: 2.408170833333333,
        date: "2025-06-10T10:19:04.000Z",
      },
      {
        lat: 48.83527083333333,
        lon: 2.4078825,
        date: "2025-06-10T10:19:07.000Z",
      },
      {
        lat: 48.83537944444445,
        lon: 2.4075788888888887,
        date: "2025-06-10T10:19:10.000Z",
      },
      {
        lat: 48.83538726,
        lon: 2.40749878,
        date: "2025-06-10T10:19:13.000Z",
      },
      {
        lat: 48.83538904,
        lon: 2.40750158,
        date: "2025-06-10T10:19:16.000Z",
      },
      {
        lat: 48.83539226,
        lon: 2.40750309,
        date: "2025-06-10T10:19:19.000Z",
      },
      {
        lat: 48.835409444444444,
        lon: 2.4074927777777777,
        date: "2025-06-10T10:19:22.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:25.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:28.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:31.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:34.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:37.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:40.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:43.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:46.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:49.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:52.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:55.000Z",
      },
      {
        lat: 48.835413333333335,
        lon: 2.407481944444444,
        date: "2025-06-10T10:19:58.000Z",
      },
      {
        lat: 48.835433333333334,
        lon: 2.4074174999999998,
        date: "2025-06-10T10:20:01.000Z",
      },
      {
        lat: 48.835499444444444,
        lon: 2.407221388888889,
        date: "2025-06-10T10:20:04.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:07.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:10.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:13.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:16.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:19.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:22.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:25.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:28.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:31.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:34.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:37.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:40.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:43.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:46.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:49.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:52.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:55.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:20:58.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:01.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:04.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:07.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:10.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:13.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:16.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:19.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:22.000Z",
      },
      {
        lat: 48.83551722222222,
        lon: 2.4071619444444443,
        date: "2025-06-10T10:21:25.000Z",
      },
      {
        lat: 48.835547222222225,
        lon: 2.4070605555555553,
        date: "2025-06-10T10:21:28.000Z",
      },
      {
        lat: 48.835616944444446,
        lon: 2.406772777777778,
        date: "2025-06-10T10:21:31.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:34.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:37.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:40.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:43.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:46.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:49.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:52.000Z",
      },
      {
        lat: 48.83562222222223,
        lon: 2.4065666666666665,
        date: "2025-06-10T10:21:55.000Z",
      },
      {
        lat: 48.8354875,
        lon: 2.4064205555555556,
        date: "2025-06-10T10:21:58.000Z",
      },
      {
        lat: 48.835484722222226,
        lon: 2.4064180555555557,
        date: "2025-06-10T10:22:01.000Z",
      },
      {
        lat: 48.835482222222225,
        lon: 2.4064166666666664,
        date: "2025-06-10T10:22:04.000Z",
      },
      {
        lat: 48.835482222222225,
        lon: 2.4064166666666664,
        date: "2025-06-10T10:22:07.000Z",
      },
      {
        lat: 48.835482222222225,
        lon: 2.4064147222222223,
        date: "2025-06-10T10:22:10.000Z",
      },
      {
        lat: 48.83547777777778,
        lon: 2.406411111111111,
        date: "2025-06-10T10:22:13.000Z",
      },
      {
        lat: 48.83545416666667,
        lon: 2.4063808333333334,
        date: "2025-06-10T10:22:16.000Z",
      },
      {
        lat: 48.83540277777778,
        lon: 2.406305833333333,
        date: "2025-06-10T10:22:19.000Z",
      },
      {
        lat: 48.835324444444446,
        lon: 2.406156944444444,
        date: "2025-06-10T10:22:22.000Z",
      },
      {
        lat: 48.835277500000004,
        lon: 2.4060741666666665,
        date: "2025-06-10T10:22:25.000Z",
      },
      {
        lat: 48.83525,
        lon: 2.406024722222222,
        date: "2025-06-10T10:22:28.000Z",
      },
      {
        lat: 48.835212222222225,
        lon: 2.4059616666666668,
        date: "2025-06-10T10:22:31.000Z",
      },
      {
        lat: 48.835096944444444,
        lon: 2.4057744444444444,
        date: "2025-06-10T10:22:34.000Z",
      },
      {
        lat: 48.83496916666667,
        lon: 2.405568333333333,
        date: "2025-06-10T10:22:37.000Z",
      },
      {
        lat: 48.83482305555556,
        lon: 2.405357222222222,
        date: "2025-06-10T10:22:40.000Z",
      },
      {
        lat: 48.834657222222226,
        lon: 2.4050969444444443,
        date: "2025-06-10T10:22:43.000Z",
      },
      {
        lat: 48.83454027777778,
        lon: 2.4049055555555556,
        date: "2025-06-10T10:22:46.000Z",
      },
      {
        lat: 48.83439638888889,
        lon: 2.4046369444444444,
        date: "2025-06-10T10:22:49.000Z",
      },
      {
        lat: 48.83423444444445,
        lon: 2.404286111111111,
        date: "2025-06-10T10:22:52.000Z",
      },
      {
        lat: 48.834076111111116,
        lon: 2.4038733333333333,
        date: "2025-06-10T10:22:55.000Z",
      },
      {
        lat: 48.833940000000005,
        lon: 2.4035175,
        date: "2025-06-10T10:22:58.000Z",
      },
      {
        lat: 48.83380583333334,
        lon: 2.403140833333333,
        date: "2025-06-10T10:23:01.000Z",
      },
      {
        lat: 48.83368611111111,
        lon: 2.4027908333333334,
        date: "2025-06-10T10:23:04.000Z",
      },
      {
        lat: 48.83360416666667,
        lon: 2.4025258333333332,
        date: "2025-06-10T10:23:07.000Z",
      },
      {
        lat: 48.83350361111111,
        lon: 2.4022502777777777,
        date: "2025-06-10T10:23:10.000Z",
      },
      {
        lat: 48.83332888888889,
        lon: 2.4018041666666665,
        date: "2025-06-10T10:23:13.000Z",
      },
      {
        lat: 48.83317305555556,
        lon: 2.4013405555555556,
        date: "2025-06-10T10:23:16.000Z",
      },
      {
        lat: 48.833018888888894,
        lon: 2.40088,
        date: "2025-06-10T10:23:19.000Z",
      },
      {
        lat: 48.83283777777778,
        lon: 2.4003663888888886,
        date: "2025-06-10T10:23:22.000Z",
      },
      {
        lat: 48.832637222222225,
        lon: 2.3998244444444445,
        date: "2025-06-10T10:23:25.000Z",
      },
      {
        lat: 48.83247666666667,
        lon: 2.399347777777778,
        date: "2025-06-10T10:23:28.000Z",
      },
      {
        lat: 48.832346944444446,
        lon: 2.398951388888889,
        date: "2025-06-10T10:23:31.000Z",
      },
      {
        lat: 48.83226555555556,
        lon: 2.3987525,
        date: "2025-06-10T10:23:34.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:37.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:40.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:43.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:46.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:49.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:52.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:55.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:23:58.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:24:01.000Z",
      },
      {
        lat: 48.83224055555556,
        lon: 2.398716388888889,
        date: "2025-06-10T10:24:04.000Z",
      },
      {
        lat: 48.83220722222222,
        lon: 2.3986466666666666,
        date: "2025-06-10T10:24:07.000Z",
      },
      {
        lat: 48.83207277777778,
        lon: 2.398335,
        date: "2025-06-10T10:24:10.000Z",
      },
      {
        lat: 48.83192944444445,
        lon: 2.3979666666666666,
        date: "2025-06-10T10:24:13.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:16.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:19.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:22.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:25.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:28.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:31.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:34.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:37.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:40.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:43.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:46.000Z",
      },
      {
        lat: 48.831920555555556,
        lon: 2.3979488888888887,
        date: "2025-06-10T10:24:49.000Z",
      },
      {
        lat: 48.83182805555556,
        lon: 2.397738611111111,
        date: "2025-06-10T10:24:52.000Z",
      },
      {
        lat: 48.831632222222225,
        lon: 2.3973222222222224,
        date: "2025-06-10T10:24:55.000Z",
      },
      {
        lat: 48.83137694444445,
        lon: 2.3967255555555553,
        date: "2025-06-10T10:24:58.000Z",
      },
      {
        lat: 48.83112027777778,
        lon: 2.3960880555555555,
        date: "2025-06-10T10:25:01.000Z",
      },
      {
        lat: 48.83090805555556,
        lon: 2.395418333333333,
        date: "2025-06-10T10:25:04.000Z",
      },
      {
        lat: 48.83073305555556,
        lon: 2.3947480555555556,
        date: "2025-06-10T10:25:07.000Z",
      },
      {
        lat: 48.830579444444446,
        lon: 2.394070833333333,
        date: "2025-06-10T10:25:10.000Z",
      },
      {
        lat: 48.83045888888889,
        lon: 2.3934438888888887,
        date: "2025-06-10T10:25:13.000Z",
      },
      {
        lat: 48.83034527777778,
        lon: 2.3928797222222222,
        date: "2025-06-10T10:25:16.000Z",
      },
      {
        lat: 48.830200277777784,
        lon: 2.392421388888889,
        date: "2025-06-10T10:25:19.000Z",
      },
      {
        lat: 48.82998388888889,
        lon: 2.3919391666666665,
        date: "2025-06-10T10:25:22.000Z",
      },
      {
        lat: 48.82980472222223,
        lon: 2.3914,
        date: "2025-06-10T10:25:25.000Z",
      },
      {
        lat: 48.82963055555556,
        lon: 2.390969166666667,
        date: "2025-06-10T10:25:28.000Z",
      },
      {
        lat: 48.82951944444445,
        lon: 2.390705833333333,
        date: "2025-06-10T10:25:31.000Z",
      },
      {
        lat: 48.82948555555556,
        lon: 2.3906133333333335,
        date: "2025-06-10T10:25:34.000Z",
      },
      {
        lat: 48.82948555555556,
        lon: 2.3906133333333335,
        date: "2025-06-10T10:25:37.000Z",
      },
      {
        lat: 48.82948555555556,
        lon: 2.3906133333333335,
        date: "2025-06-10T10:25:40.000Z",
      },
      {
        lat: 48.82948555555556,
        lon: 2.3906133333333335,
        date: "2025-06-10T10:25:43.000Z",
      },
      {
        lat: 48.82948555555556,
        lon: 2.3906133333333335,
        date: "2025-06-10T10:25:46.000Z",
      },
      {
        lat: 48.82948555555556,
        lon: 2.3906133333333335,
        date: "2025-06-10T10:25:49.000Z",
      },
      {
        lat: 48.829478333333334,
        lon: 2.3905802777777776,
        date: "2025-06-10T10:25:52.000Z",
      },
      {
        lat: 48.829478333333334,
        lon: 2.3905802777777776,
        date: "2025-06-10T10:25:55.000Z",
      },
      {
        lat: 48.82946833333334,
        lon: 2.39056,
        date: "2025-06-10T10:25:58.000Z",
      },
      {
        lat: 48.82936666666667,
        lon: 2.3903141666666667,
        date: "2025-06-10T10:26:01.000Z",
      },
      {
        lat: 48.82933361111112,
        lon: 2.3902402777777776,
        date: "2025-06-10T10:26:04.000Z",
      },
      {
        lat: 48.82907222222222,
        lon: 2.3896183333333334,
        date: "2025-06-10T10:26:07.000Z",
      },
      {
        lat: 48.82888166666667,
        lon: 2.3891002777777777,
        date: "2025-06-10T10:26:10.000Z",
      },
      {
        lat: 48.82866888888889,
        lon: 2.3886005555555556,
        date: "2025-06-10T10:26:13.000Z",
      },
      {
        lat: 48.82846833333333,
        lon: 2.3881616666666665,
        date: "2025-06-10T10:26:16.000Z",
      },
      {
        lat: 48.82826611111111,
        lon: 2.3877527777777776,
        date: "2025-06-10T10:26:19.000Z",
      },
      {
        lat: 48.82806916666667,
        lon: 2.387388888888889,
        date: "2025-06-10T10:26:22.000Z",
      },
      {
        lat: 48.82787972222223,
        lon: 2.387006388888889,
        date: "2025-06-10T10:26:25.000Z",
      },
      {
        lat: 48.82771,
        lon: 2.3866566666666666,
        date: "2025-06-10T10:26:28.000Z",
      },
      {
        lat: 48.82756861111111,
        lon: 2.386359166666667,
        date: "2025-06-10T10:26:31.000Z",
      },
      {
        lat: 48.827487222222224,
        lon: 2.386186388888889,
        date: "2025-06-10T10:26:34.000Z",
      },
      {
        lat: 48.827415,
        lon: 2.386044722222222,
        date: "2025-06-10T10:26:37.000Z",
      },
      {
        lat: 48.82736361111112,
        lon: 2.3859466666666664,
        date: "2025-06-10T10:26:40.000Z",
      },
      {
        lat: 48.82725333333334,
        lon: 2.385727222222222,
        date: "2025-06-10T10:26:43.000Z",
      },
      {
        lat: 48.82717416666667,
        lon: 2.385553611111111,
        date: "2025-06-10T10:26:46.000Z",
      },
      {
        lat: 48.82713666666667,
        lon: 2.385443611111111,
        date: "2025-06-10T10:26:49.000Z",
      },
      {
        lat: 48.827108055555556,
        lon: 2.3853822222222223,
        date: "2025-06-10T10:26:52.000Z",
      },
      {
        lat: 48.82708277777778,
        lon: 2.3853244444444446,
        date: "2025-06-10T10:26:55.000Z",
      },
      {
        lat: 48.82707972222222,
        lon: 2.3852891666666665,
        date: "2025-06-10T10:26:58.000Z",
      },
      {
        lat: 48.82704527777778,
        lon: 2.3851952777777776,
        date: "2025-06-10T10:27:01.000Z",
      },
      {
        lat: 48.8270125,
        lon: 2.385118888888889,
        date: "2025-06-10T10:27:04.000Z",
      },
    ],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc3998b01",
    registrationNumber: "IS-987-AT",
    model: "DACIA",
    reference: "Geoloc 3",
    lastLatitude: 48.55975194444444,
    lastLongitude: 2.4277027777777778,
    distance: 0,
    driverName: "Jeanne Doe",
    driverPhone: "07XXX35678",
    dataPoints: [
      {
        lat: 48.56820722222223,
        lon: 2.446585277777778,
        date: "2025-05-26T17:14:38.000Z",
      },
      {
        lat: 48.56823055555556,
        lon: 2.4466186111111115,
        date: "2025-05-26T17:14:53.000Z",
      },
      {
        lat: 48.56823666666667,
        lon: 2.4466411111111115,
        date: "2025-05-26T17:14:56.000Z",
      },
      {
        lat: 48.56823166666667,
        lon: 2.446645,
        date: "2025-05-26T17:14:59.000Z",
      },
      {
        lat: 48.56820916666667,
        lon: 2.446501388888889,
        date: "2025-05-26T17:15:02.000Z",
      },
      {
        lat: 48.56817305555556,
        lon: 2.4463397222222225,
        date: "2025-05-26T17:15:05.000Z",
      },
      {
        lat: 48.56816861111111,
        lon: 2.4461469444444446,
        date: "2025-05-26T17:15:08.000Z",
      },
      {
        lat: 48.56819416666667,
        lon: 2.4459569444444447,
        date: "2025-05-26T17:15:11.000Z",
      },
      {
        lat: 48.56818194444445,
        lon: 2.4457694444444447,
        date: "2025-05-26T17:15:14.000Z",
      },
      {
        lat: 48.56817166666667,
        lon: 2.4456272222222224,
        date: "2025-05-26T17:15:17.000Z",
      },
      {
        lat: 48.56810222222222,
        lon: 2.445549166666667,
        date: "2025-05-26T17:15:20.000Z",
      },
      {
        lat: 48.56792,
        lon: 2.445582777777778,
        date: "2025-05-26T17:15:23.000Z",
      },
      {
        lat: 48.5677875,
        lon: 2.4456294444444446,
        date: "2025-05-26T17:15:26.000Z",
      },
      {
        lat: 48.56762916666667,
        lon: 2.445669166666667,
        date: "2025-05-26T17:15:29.000Z",
      },
      {
        lat: 48.56749361111112,
        lon: 2.445702777777778,
        date: "2025-05-26T17:15:32.000Z",
      },
      {
        lat: 48.567442222222226,
        lon: 2.4457133333333334,
        date: "2025-05-26T17:15:35.000Z",
      },
      {
        lat: 48.567442222222226,
        lon: 2.4457133333333334,
        date: "2025-05-26T17:15:38.000Z",
      },
      {
        lat: 48.567442222222226,
        lon: 2.4457133333333334,
        date: "2025-05-26T17:15:41.000Z",
      },
      {
        lat: 48.56733638888889,
        lon: 2.4457858333333338,
        date: "2025-05-26T17:15:44.000Z",
      },
      {
        lat: 48.56727444444445,
        lon: 2.446207777777778,
        date: "2025-05-26T17:15:47.000Z",
      },
      {
        lat: 48.56726444444445,
        lon: 2.4466019444444447,
        date: "2025-05-26T17:15:50.000Z",
      },
      {
        lat: 48.5672525,
        lon: 2.447,
        date: "2025-05-26T17:15:53.000Z",
      },
      {
        lat: 48.56725361111111,
        lon: 2.447374166666667,
        date: "2025-05-26T17:15:56.000Z",
      },
      {
        lat: 48.56730416666667,
        lon: 2.447750277777778,
        date: "2025-05-26T17:15:59.000Z",
      },
      {
        lat: 48.5673425,
        lon: 2.4480558333333335,
        date: "2025-05-26T17:16:02.000Z",
      },
      {
        lat: 48.56734166666667,
        lon: 2.448283888888889,
        date: "2025-05-26T17:16:05.000Z",
      },
      {
        lat: 48.56725027777778,
        lon: 2.4483988888888892,
        date: "2025-05-26T17:16:08.000Z",
      },
      {
        lat: 48.567233611111114,
        lon: 2.448412777777778,
        date: "2025-05-26T17:16:11.000Z",
      },
      {
        lat: 48.567233611111114,
        lon: 2.448412777777778,
        date: "2025-05-26T17:16:14.000Z",
      },
      {
        lat: 48.567233611111114,
        lon: 2.448412777777778,
        date: "2025-05-26T17:16:17.000Z",
      },
      {
        lat: 48.56722833333334,
        lon: 2.4484166666666667,
        date: "2025-05-26T17:16:20.000Z",
      },
      {
        lat: 48.56722833333334,
        lon: 2.4484166666666667,
        date: "2025-05-26T17:16:23.000Z",
      },
      {
        lat: 48.56722833333334,
        lon: 2.4484166666666667,
        date: "2025-05-26T17:16:26.000Z",
      },
      {
        lat: 48.56711055555556,
        lon: 2.4483711111111113,
        date: "2025-05-26T17:16:29.000Z",
      },
      {
        lat: 48.566905000000006,
        lon: 2.4482094444444447,
        date: "2025-05-26T17:16:32.000Z",
      },
      {
        lat: 48.56679194444445,
        lon: 2.4478700000000004,
        date: "2025-05-26T17:16:35.000Z",
      },
      {
        lat: 48.56676666666667,
        lon: 2.4474258333333334,
        date: "2025-05-26T17:16:38.000Z",
      },
      {
        lat: 48.56678555555556,
        lon: 2.446965,
        date: "2025-05-26T17:16:41.000Z",
      },
      {
        lat: 48.56682166666667,
        lon: 2.4464722222222224,
        date: "2025-05-26T17:16:44.000Z",
      },
      {
        lat: 48.566816111111116,
        lon: 2.4459647222222225,
        date: "2025-05-26T17:16:47.000Z",
      },
      {
        lat: 48.56675333333334,
        lon: 2.445473888888889,
        date: "2025-05-26T17:16:50.000Z",
      },
      {
        lat: 48.56668305555556,
        lon: 2.445140277777778,
        date: "2025-05-26T17:16:53.000Z",
      },
      {
        lat: 48.566581388888885,
        lon: 2.4446600000000003,
        date: "2025-05-26T17:16:56.000Z",
      },
      {
        lat: 48.56648027777778,
        lon: 2.444200277777778,
        date: "2025-05-26T17:16:59.000Z",
      },
      {
        lat: 48.566382777777775,
        lon: 2.443729166666667,
        date: "2025-05-26T17:17:02.000Z",
      },
      {
        lat: 48.56628305555555,
        lon: 2.4432694444444447,
        date: "2025-05-26T17:17:05.000Z",
      },
      {
        lat: 48.56616861111111,
        lon: 2.442751666666667,
        date: "2025-05-26T17:17:08.000Z",
      },
      {
        lat: 48.566046111111106,
        lon: 2.442173888888889,
        date: "2025-05-26T17:17:11.000Z",
      },
      {
        lat: 48.565934166666665,
        lon: 2.4416494444444448,
        date: "2025-05-26T17:17:14.000Z",
      },
      {
        lat: 48.56582694444444,
        lon: 2.4411483333333335,
        date: "2025-05-26T17:17:17.000Z",
      },
      {
        lat: 48.565727499999994,
        lon: 2.4406947222222226,
        date: "2025-05-26T17:17:20.000Z",
      },
      {
        lat: 48.56562805555555,
        lon: 2.4402266666666668,
        date: "2025-05-26T17:17:23.000Z",
      },
      {
        lat: 48.56554583333333,
        lon: 2.4398463888888893,
        date: "2025-05-26T17:17:26.000Z",
      },
      {
        lat: 48.56547388888889,
        lon: 2.439521388888889,
        date: "2025-05-26T17:17:29.000Z",
      },
      {
        lat: 48.565417777777775,
        lon: 2.439257777777778,
        date: "2025-05-26T17:17:32.000Z",
      },
      {
        lat: 48.565353055555555,
        lon: 2.438962777777778,
        date: "2025-05-26T17:17:35.000Z",
      },
      {
        lat: 48.56528194444444,
        lon: 2.4386475,
        date: "2025-05-26T17:17:38.000Z",
      },
      {
        lat: 48.565212499999994,
        lon: 2.4383616666666668,
        date: "2025-05-26T17:17:41.000Z",
      },
      {
        lat: 48.56514194444444,
        lon: 2.4380661111111115,
        date: "2025-05-26T17:17:44.000Z",
      },
      {
        lat: 48.56512333333333,
        lon: 2.4379850000000003,
        date: "2025-05-26T17:17:47.000Z",
      },
      {
        lat: 48.56511694444444,
        lon: 2.437962777777778,
        date: "2025-05-26T17:17:50.000Z",
      },
      {
        lat: 48.56509666666666,
        lon: 2.437841666666667,
        date: "2025-05-26T17:17:53.000Z",
      },
      {
        lat: 48.56504472222222,
        lon: 2.437594166666667,
        date: "2025-05-26T17:17:56.000Z",
      },
      {
        lat: 48.56498555555555,
        lon: 2.4373169444444445,
        date: "2025-05-26T17:17:59.000Z",
      },
      {
        lat: 48.56491,
        lon: 2.436997777777778,
        date: "2025-05-26T17:18:02.000Z",
      },
      {
        lat: 48.56484138888889,
        lon: 2.4367108333333336,
        date: "2025-05-26T17:18:05.000Z",
      },
      {
        lat: 48.56475583333333,
        lon: 2.4364175,
        date: "2025-05-26T17:18:08.000Z",
      },
      {
        lat: 48.56469027777778,
        lon: 2.4362308333333336,
        date: "2025-05-26T17:18:11.000Z",
      },
      {
        lat: 48.564658611111106,
        lon: 2.4361372222222224,
        date: "2025-05-26T17:18:14.000Z",
      },
      {
        lat: 48.564625,
        lon: 2.4360183333333336,
        date: "2025-05-26T17:18:17.000Z",
      },
      {
        lat: 48.564527777777776,
        lon: 2.4357894444444446,
        date: "2025-05-26T17:18:20.000Z",
      },
      {
        lat: 48.56440722222222,
        lon: 2.4355347222222226,
        date: "2025-05-26T17:18:23.000Z",
      },
      {
        lat: 48.56426555555555,
        lon: 2.435249166666667,
        date: "2025-05-26T17:18:26.000Z",
      },
      {
        lat: 48.56410722222222,
        lon: 2.4349344444444445,
        date: "2025-05-26T17:18:29.000Z",
      },
      {
        lat: 48.56394583333333,
        lon: 2.4345800000000004,
        date: "2025-05-26T17:18:32.000Z",
      },
      {
        lat: 48.56381777777778,
        lon: 2.4342247222222224,
        date: "2025-05-26T17:18:35.000Z",
      },
      {
        lat: 48.56373138888888,
        lon: 2.4339197222222224,
        date: "2025-05-26T17:18:38.000Z",
      },
      {
        lat: 48.563696666666665,
        lon: 2.433767777777778,
        date: "2025-05-26T17:18:41.000Z",
      },
      {
        lat: 48.56367583333333,
        lon: 2.4336847222222224,
        date: "2025-05-26T17:18:44.000Z",
      },
      {
        lat: 48.56366416666666,
        lon: 2.433636388888889,
        date: "2025-05-26T17:18:47.000Z",
      },
      {
        lat: 48.56366166666666,
        lon: 2.433622777777778,
        date: "2025-05-26T17:18:50.000Z",
      },
      {
        lat: 48.56366166666666,
        lon: 2.433622777777778,
        date: "2025-05-26T17:18:53.000Z",
      },
      {
        lat: 48.56366166666666,
        lon: 2.433622777777778,
        date: "2025-05-26T17:18:56.000Z",
      },
      {
        lat: 48.56366166666666,
        lon: 2.433622777777778,
        date: "2025-05-26T17:18:59.000Z",
      },
      {
        lat: 48.56366166666666,
        lon: 2.433622777777778,
        date: "2025-05-26T17:19:02.000Z",
      },
      {
        lat: 48.56366166666666,
        lon: 2.433622777777778,
        date: "2025-05-26T17:19:05.000Z",
      },
      {
        lat: 48.563655,
        lon: 2.433586666666667,
        date: "2025-05-26T17:19:08.000Z",
      },
      {
        lat: 48.563604166666664,
        lon: 2.4333708333333335,
        date: "2025-05-26T17:19:11.000Z",
      },
      {
        lat: 48.56352888888889,
        lon: 2.433071111111111,
        date: "2025-05-26T17:19:14.000Z",
      },
      {
        lat: 48.56345472222222,
        lon: 2.4327361111111108,
        date: "2025-05-26T17:19:17.000Z",
      },
      {
        lat: 48.56339722222222,
        lon: 2.4324805555555553,
        date: "2025-05-26T17:19:20.000Z",
      },
      {
        lat: 48.563292222222216,
        lon: 2.4320713888888887,
        date: "2025-05-26T17:19:23.000Z",
      },
      {
        lat: 48.563204166666665,
        lon: 2.4316725,
        date: "2025-05-26T17:19:26.000Z",
      },
      {
        lat: 48.56312166666666,
        lon: 2.4313255555555555,
        date: "2025-05-26T17:19:29.000Z",
      },
      {
        lat: 48.5630575,
        lon: 2.4310525,
        date: "2025-05-26T17:19:32.000Z",
      },
      {
        lat: 48.563015,
        lon: 2.4308716666666665,
        date: "2025-05-26T17:19:35.000Z",
      },
      {
        lat: 48.56298638888889,
        lon: 2.4307530555555554,
        date: "2025-05-26T17:19:38.000Z",
      },
      {
        lat: 48.56297305555555,
        lon: 2.430698611111111,
        date: "2025-05-26T17:19:41.000Z",
      },
      {
        lat: 48.56297083333333,
        lon: 2.4306880555555552,
        date: "2025-05-26T17:19:44.000Z",
      },
      {
        lat: 48.56295833333333,
        lon: 2.4306280555555553,
        date: "2025-05-26T17:19:47.000Z",
      },
      {
        lat: 48.56292055555555,
        lon: 2.4304788888888886,
        date: "2025-05-26T17:19:50.000Z",
      },
      {
        lat: 48.562883888888884,
        lon: 2.4303330555555553,
        date: "2025-05-26T17:19:53.000Z",
      },
      {
        lat: 48.56285527777778,
        lon: 2.4302338888888886,
        date: "2025-05-26T17:19:56.000Z",
      },
      {
        lat: 48.56283361111111,
        lon: 2.4300591666666667,
        date: "2025-05-26T17:19:59.000Z",
      },
      {
        lat: 48.56290083333333,
        lon: 2.4297794444444443,
        date: "2025-05-26T17:20:02.000Z",
      },
      {
        lat: 48.56287222222222,
        lon: 2.4295205555555555,
        date: "2025-05-26T17:20:05.000Z",
      },
      {
        lat: 48.56268305555555,
        lon: 2.4294716666666667,
        date: "2025-05-26T17:20:08.000Z",
      },
      {
        lat: 48.562556944444445,
        lon: 2.429623611111111,
        date: "2025-05-26T17:20:11.000Z",
      },
      {
        lat: 48.56254166666666,
        lon: 2.4296569444444445,
        date: "2025-05-26T17:20:14.000Z",
      },
      {
        lat: 48.56234138888889,
        lon: 2.429393611111111,
        date: "2025-05-26T17:20:17.000Z",
      },
      {
        lat: 48.56219944444444,
        lon: 2.4290599999999998,
        date: "2025-05-26T17:20:20.000Z",
      },
      {
        lat: 48.56207388888889,
        lon: 2.4288377777777774,
        date: "2025-05-26T17:20:23.000Z",
      },
      {
        lat: 48.561994999999996,
        lon: 2.428710833333333,
        date: "2025-05-26T17:20:26.000Z",
      },
      {
        lat: 48.56184416666667,
        lon: 2.4284825,
        date: "2025-05-26T17:20:29.000Z",
      },
      {
        lat: 48.56162888888888,
        lon: 2.428141111111111,
        date: "2025-05-26T17:20:32.000Z",
      },
      {
        lat: 48.56139888888889,
        lon: 2.4277675,
        date: "2025-05-26T17:20:35.000Z",
      },
      {
        lat: 48.56122305555555,
        lon: 2.4274733333333334,
        date: "2025-05-26T17:20:38.000Z",
      },
      {
        lat: 48.56106611111111,
        lon: 2.4272099999999996,
        date: "2025-05-26T17:20:41.000Z",
      },
      {
        lat: 48.56097027777778,
        lon: 2.427166111111111,
        date: "2025-05-26T17:20:44.000Z",
      },
      {
        lat: 48.56088305555555,
        lon: 2.4272891666666667,
        date: "2025-05-26T17:20:47.000Z",
      },
      {
        lat: 48.56079777777777,
        lon: 2.4274544444444444,
        date: "2025-05-26T17:20:50.000Z",
      },
      {
        lat: 48.560696388888886,
        lon: 2.4276166666666663,
        date: "2025-05-26T17:20:53.000Z",
      },
      {
        lat: 48.56058083333333,
        lon: 2.4278069444444443,
        date: "2025-05-26T17:20:56.000Z",
      },
      {
        lat: 48.56048111111111,
        lon: 2.427985833333333,
        date: "2025-05-26T17:20:59.000Z",
      },
      {
        lat: 48.56039527777777,
        lon: 2.428159722222222,
        date: "2025-05-26T17:21:02.000Z",
      },
      {
        lat: 48.56031861111111,
        lon: 2.4281941666666667,
        date: "2025-05-26T17:21:05.000Z",
      },
      {
        lat: 48.56024444444444,
        lon: 2.4281341666666667,
        date: "2025-05-26T17:21:08.000Z",
      },
      {
        lat: 48.56014694444444,
        lon: 2.428008888888889,
        date: "2025-05-26T17:21:11.000Z",
      },
      {
        lat: 48.56003333333333,
        lon: 2.4278549999999997,
        date: "2025-05-26T17:21:14.000Z",
      },
      {
        lat: 48.559936666666665,
        lon: 2.42773,
        date: "2025-05-26T17:21:17.000Z",
      },
      {
        lat: 48.559893055555555,
        lon: 2.4276791666666666,
        date: "2025-05-26T17:21:20.000Z",
      },
      {
        lat: 48.55985138888889,
        lon: 2.4276669444444443,
        date: "2025-05-26T17:21:23.000Z",
      },
      {
        lat: 48.55981416666666,
        lon: 2.4277027777777778,
        date: "2025-05-26T17:21:26.000Z",
      },
      {
        lat: 48.55979722222222,
        lon: 2.427763611111111,
        date: "2025-05-26T17:21:29.000Z",
      },
      {
        lat: 48.55979416666666,
        lon: 2.4277563888888887,
        date: "2025-05-26T17:21:32.000Z",
      },
      {
        lat: 48.55977138888888,
        lon: 2.4277177777777776,
        date: "2025-05-26T17:21:35.000Z",
      },
      {
        lat: 48.55975194444444,
        lon: 2.4277027777777778,
        date: "2025-05-26T17:21:38.000Z",
      },
    ],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc399802",
    registrationNumber: "TI-123-ON",
    model: "X3",
    reference: "Geoloc 4",
    lastLatitude: 48.75,
    lastLongitude: 2.4,
    distance: 0,
    driverName: "Grace Johns",
    driverPhone: "07XXX45566",
    dataPoints: [],
  },
  {
    uuid: "e66252a8-a353-4096-a592-88b0dc399803",
    registrationNumber: "AA-123-ZZ",
    model: "CLIO",
    reference: "Geoloc 5",
    lastLatitude: 48.85737356,
    lastLongitude: 2.30970324,
    distance: 0,
    driverName: "Jean Legrand",
    driverPhone: "07XXX70707",
    dataPoints: [
      {
        lat: 48.89237077,
        lon: 2.23842997,
        date: "2026-07-22T07:45:00.000Z",
      },
      {
        lat: 48.8922518,
        lon: 2.23880607,
        date: "2026-07-22T07:45:03.000Z",
      },
      {
        lat: 48.89214256,
        lon: 2.23916764,
        date: "2026-07-22T07:45:06.000Z",
      },
      {
        lat: 48.89202554,
        lon: 2.23953192,
        date: "2026-07-22T07:45:09.000Z",
      },
      {
        lat: 48.89188869,
        lon: 2.2399142,
        date: "2026-07-22T07:45:12.000Z",
      },
      {
        lat: 48.89173379,
        lon: 2.24031694,
        date: "2026-07-22T07:45:15.000Z",
      },
      {
        lat: 48.89157525,
        lon: 2.24072798,
        date: "2026-07-22T07:45:18.000Z",
      },
      {
        lat: 48.89143001,
        lon: 2.24112925,
        date: "2026-07-22T07:45:21.000Z",
      },
      {
        lat: 48.89130571,
        lon: 2.24150963,
        date: "2026-07-22T07:45:24.000Z",
      },
      {
        lat: 48.89119538,
        lon: 2.24187294,
        date: "2026-07-22T07:45:27.000Z",
      },
      {
        lat: 48.8910823,
        lon: 2.24223517,
        date: "2026-07-22T07:45:30.000Z",
      },
      {
        lat: 48.89095164,
        lon: 2.24261309,
        date: "2026-07-22T07:45:33.000Z",
      },
      {
        lat: 48.89080088,
        lon: 2.24301225,
        date: "2026-07-22T07:45:36.000Z",
      },
      {
        lat: 48.89064152,
        lon: 2.24342307,
        date: "2026-07-22T07:45:39.000Z",
      },
      {
        lat: 48.89049108,
        lon: 2.24382762,
        date: "2026-07-22T07:45:42.000Z",
      },
      {
        lat: 48.89036084,
        lon: 2.24421245,
        date: "2026-07-22T07:45:45.000Z",
      },
      {
        lat: 48.89024797,
        lon: 2.24457819,
        date: "2026-07-22T07:45:48.000Z",
      },
      {
        lat: 48.89013752,
        lon: 2.24493911,
        date: "2026-07-22T07:45:51.000Z",
      },
      {
        lat: 48.89001284,
        lon: 2.2453129,
        date: "2026-07-22T07:45:54.000Z",
      },
      {
        lat: 48.88986721,
        lon: 2.24570808,
        date: "2026-07-22T07:45:57.000Z",
      },
      {
        lat: 48.88970857,
        lon: 2.24611788,
        date: "2026-07-22T07:46:00.000Z",
      },
      {
        lat: 48.88955392,
        lon: 2.24652512,
        date: "2026-07-22T07:46:03.000Z",
      },
      {
        lat: 48.88941748,
        lon: 2.24691443,
        date: "2026-07-22T07:46:06.000Z",
      },
      {
        lat: 48.88930077,
        lon: 2.24728323,
        date: "2026-07-22T07:46:09.000Z",
      },
      {
        lat: 48.8891915,
        lon: 2.24764361,
        date: "2026-07-22T07:46:12.000Z",
      },
      {
        lat: 48.8890722,
        lon: 2.24801365,
        date: "2026-07-22T07:46:15.000Z",
      },
      {
        lat: 48.88893241,
        lon: 2.24840454,
        date: "2026-07-22T07:46:18.000Z",
      },
      {
        lat: 48.88877597,
        lon: 2.24881258,
        date: "2026-07-22T07:46:21.000Z",
      },
      {
        lat: 48.88861835,
        lon: 2.24922184,
        date: "2026-07-22T07:46:24.000Z",
      },
      {
        lat: 48.88847586,
        lon: 2.24961551,
        date: "2026-07-22T07:46:27.000Z",
      },
      {
        lat: 48.88835422,
        lon: 2.2499879,
        date: "2026-07-22T07:46:30.000Z",
      },
      {
        lat: 48.8882446,
        lon: 2.25034854,
        date: "2026-07-22T07:46:33.000Z",
      },
      {
        lat: 48.88812977,
        lon: 2.25071531,
        date: "2026-07-22T07:46:36.000Z",
      },
      {
        lat: 48.88799615,
        lon: 2.25110175,
        date: "2026-07-22T07:46:39.000Z",
      },
      {
        lat: 48.88784326,
        lon: 2.25150734,
        date: "2026-07-22T07:46:42.000Z",
      },
      {
        lat: 48.88768411,
        lon: 2.25191788,
        date: "2026-07-22T07:46:45.000Z",
      },
      {
        lat: 48.88743761,
        lon: 2.25242631,
        date: "2026-07-22T07:46:48.000Z",
      },
      {
        lat: 48.88719134,
        lon: 2.25298107,
        date: "2026-07-22T07:46:51.000Z",
      },
      {
        lat: 48.88694522,
        lon: 2.25357285,
        date: "2026-07-22T07:46:54.000Z",
      },
      {
        lat: 48.88669918,
        lon: 2.25411994,
        date: "2026-07-22T07:46:57.000Z",
      },
      {
        lat: 48.88645316,
        lon: 2.25462803,
        date: "2026-07-22T07:47:00.000Z",
      },
      {
        lat: 48.88620708,
        lon: 2.25517909,
        date: "2026-07-22T07:47:03.000Z",
      },
      {
        lat: 48.88596087,
        lon: 2.25577104,
        date: "2026-07-22T07:47:06.000Z",
      },
      {
        lat: 48.88571448,
        lon: 2.25632184,
        date: "2026-07-22T07:47:09.000Z",
      },
      {
        lat: 48.88546783,
        lon: 2.25682993,
        date: "2026-07-22T07:47:12.000Z",
      },
      {
        lat: 48.88522086,
        lon: 2.25737727,
        date: "2026-07-22T07:47:15.000Z",
      },
      {
        lat: 48.88497353,
        lon: 2.25796907,
        date: "2026-07-22T07:47:18.000Z",
      },
      {
        lat: 48.88472579,
        lon: 2.25852358,
        date: "2026-07-22T07:47:21.000Z",
      },
      {
        lat: 48.88447759,
        lon: 2.25903198,
        date: "2026-07-22T07:47:24.000Z",
      },
      {
        lat: 48.88422891,
        lon: 2.25957563,
        date: "2026-07-22T07:47:27.000Z",
      },
      {
        lat: 48.88397971,
        lon: 2.26016695,
        date: "2026-07-22T07:47:30.000Z",
      },
      {
        lat: 48.88373,
        lon: 2.26072512,
        date: "2026-07-22T07:47:33.000Z",
      },
      {
        lat: 48.88347976,
        lon: 2.26123417,
        date: "2026-07-22T07:47:36.000Z",
      },
      {
        lat: 48.88322899,
        lon: 2.26177418,
        date: "2026-07-22T07:47:39.000Z",
      },
      {
        lat: 48.88297771,
        lon: 2.26236469,
        date: "2026-07-22T07:47:42.000Z",
      },
      {
        lat: 48.88272595,
        lon: 2.26292648,
        date: "2026-07-22T07:47:45.000Z",
      },
      {
        lat: 48.88247373,
        lon: 2.26343648,
        date: "2026-07-22T07:47:48.000Z",
      },
      {
        lat: 48.88222109,
        lon: 2.26397293,
        date: "2026-07-22T07:47:51.000Z",
      },
      {
        lat: 48.88196808,
        lon: 2.26456232,
        date: "2026-07-22T07:47:54.000Z",
      },
      {
        lat: 48.88171475,
        lon: 2.26512762,
        date: "2026-07-22T07:47:57.000Z",
      },
      {
        lat: 48.88146117,
        lon: 2.2656389,
        date: "2026-07-22T07:48:00.000Z",
      },
      {
        lat: 48.88120738,
        lon: 2.26617189,
        date: "2026-07-22T07:48:03.000Z",
      },
      {
        lat: 48.88095347,
        lon: 2.26675986,
        date: "2026-07-22T07:48:06.000Z",
      },
      {
        lat: 48.8806995,
        lon: 2.26732855,
        date: "2026-07-22T07:48:09.000Z",
      },
      {
        lat: 48.88044553,
        lon: 2.26784141,
        date: "2026-07-22T07:48:12.000Z",
      },
      {
        lat: 48.88019164,
        lon: 2.26837107,
        date: "2026-07-22T07:48:15.000Z",
      },
      {
        lat: 48.8800109,
        lon: 2.26925081,
        date: "2026-07-22T07:48:18.000Z",
      },
      {
        lat: 48.87974334,
        lon: 2.27013058,
        date: "2026-07-22T07:48:21.000Z",
      },
      {
        lat: 48.87958323,
        lon: 2.27101039,
        date: "2026-07-22T07:48:24.000Z",
      },
      {
        lat: 48.87933989,
        lon: 2.27189024,
        date: "2026-07-22T07:48:27.000Z",
      },
      {
        lat: 48.87912083,
        lon: 2.27277013,
        date: "2026-07-22T07:48:30.000Z",
      },
      {
        lat: 48.87894657,
        lon: 2.27365005,
        date: "2026-07-22T07:48:33.000Z",
      },
      {
        lat: 48.87867712,
        lon: 2.27453001,
        date: "2026-07-22T07:48:36.000Z",
      },
      {
        lat: 48.87851353,
        lon: 2.27541,
        date: "2026-07-22T07:48:39.000Z",
      },
      {
        lat: 48.87827759,
        lon: 2.27629004,
        date: "2026-07-22T07:48:42.000Z",
      },
      {
        lat: 48.87805029,
        lon: 2.27717011,
        date: "2026-07-22T07:48:45.000Z",
      },
      {
        lat: 48.87788166,
        lon: 2.27805022,
        date: "2026-07-22T07:48:48.000Z",
      },
      {
        lat: 48.87761154,
        lon: 2.27893037,
        date: "2026-07-22T07:48:51.000Z",
      },
      {
        lat: 48.87744338,
        lon: 2.27981055,
        date: "2026-07-22T07:48:54.000Z",
      },
      {
        lat: 48.87721534,
        lon: 2.28069077,
        date: "2026-07-22T07:48:57.000Z",
      },
      {
        lat: 48.87698011,
        lon: 2.28157103,
        date: "2026-07-22T07:49:00.000Z",
      },
      {
        lat: 48.87681614,
        lon: 2.28245132,
        date: "2026-07-22T07:49:03.000Z",
      },
      {
        lat: 48.87654658,
        lon: 2.28333165,
        date: "2026-07-22T07:49:06.000Z",
      },
      {
        lat: 48.87637287,
        lon: 2.28421202,
        date: "2026-07-22T07:49:09.000Z",
      },
      {
        lat: 48.87615305,
        lon: 2.28509242,
        date: "2026-07-22T07:49:12.000Z",
      },
      {
        lat: 48.87591036,
        lon: 2.28597285,
        date: "2026-07-22T07:49:15.000Z",
      },
      {
        lat: 48.87574998,
        lon: 2.28685332,
        date: "2026-07-22T07:49:18.000Z",
      },
      {
        lat: 48.8754822,
        lon: 2.28773383,
        date: "2026-07-22T07:49:21.000Z",
      },
      {
        lat: 48.87530208,
        lon: 2.28861436,
        date: "2026-07-22T07:49:24.000Z",
      },
      {
        lat: 48.87509062,
        lon: 2.28949493,
        date: "2026-07-22T07:49:27.000Z",
      },
      {
        lat: 48.87484111,
        lon: 2.29037553,
        date: "2026-07-22T07:49:30.000Z",
      },
      {
        lat: 48.87468316,
        lon: 2.29125616,
        date: "2026-07-22T07:49:33.000Z",
      },
      {
        lat: 48.87441835,
        lon: 2.29213682,
        date: "2026-07-22T07:49:36.000Z",
      },
      {
        lat: 48.8742311,
        lon: 2.29301751,
        date: "2026-07-22T07:49:39.000Z",
      },
      {
        lat: 48.87402796,
        lon: 2.29389822,
        date: "2026-07-22T07:49:42.000Z",
      },
      {
        lat: 48.87377241,
        lon: 2.29477897,
        date: "2026-07-22T07:49:45.000Z",
      },
      {
        lat: 48.87364837,
        lon: 2.29519973,
        date: "2026-07-22T07:49:48.000Z",
      },
      {
        lat: 48.87352627,
        lon: 2.29560713,
        date: "2026-07-22T07:49:51.000Z",
      },
      {
        lat: 48.87340557,
        lon: 2.29597861,
        date: "2026-07-22T07:49:54.000Z",
      },
      {
        lat: 48.87328559,
        lon: 2.29633465,
        date: "2026-07-22T07:49:57.000Z",
      },
      {
        lat: 48.87316562,
        lon: 2.2967142,
        date: "2026-07-22T07:50:00.000Z",
      },
      {
        lat: 48.87304495,
        lon: 2.29712808,
        date: "2026-07-22T07:50:03.000Z",
      },
      {
        lat: 48.87292289,
        lon: 2.29754596,
        date: "2026-07-22T07:50:06.000Z",
      },
      {
        lat: 48.87279892,
        lon: 2.29793275,
        date: "2026-07-22T07:50:09.000Z",
      },
      {
        lat: 48.87267264,
        lon: 2.29829058,
        date: "2026-07-22T07:50:12.000Z",
      },
      {
        lat: 48.87254385,
        lon: 2.29865627,
        date: "2026-07-22T07:50:15.000Z",
      },
      {
        lat: 48.87241259,
        lon: 2.29905722,
        date: "2026-07-22T07:50:18.000Z",
      },
      {
        lat: 48.87227907,
        lon: 2.29947862,
        date: "2026-07-22T07:50:21.000Z",
      },
      {
        lat: 48.87214371,
        lon: 2.29988113,
        date: "2026-07-22T07:50:24.000Z",
      },
      {
        lat: 48.87200707,
        lon: 2.30024807,
        date: "2026-07-22T07:50:27.000Z",
      },
      {
        lat: 48.87186985,
        lon: 2.30060534,
        date: "2026-07-22T07:50:30.000Z",
      },
      {
        lat: 48.87173275,
        lon: 2.30099043,
        date: "2026-07-22T07:50:33.000Z",
      },
      {
        lat: 48.87159651,
        lon: 2.30140751,
        date: "2026-07-22T07:50:36.000Z",
      },
      {
        lat: 48.87146175,
        lon: 2.30182244,
        date: "2026-07-22T07:50:39.000Z",
      },
      {
        lat: 48.87132901,
        lon: 2.30220364,
        date: "2026-07-22T07:50:42.000Z",
      },
      {
        lat: 48.87119863,
        lon: 2.30255995,
        date: "2026-07-22T07:50:45.000Z",
      },
      {
        lat: 48.87107077,
        lon: 2.30293001,
        date: "2026-07-22T07:50:48.000Z",
      },
      {
        lat: 48.87094536,
        lon: 2.30333598,
        date: "2026-07-22T07:50:51.000Z",
      },
      {
        lat: 48.87082213,
        lon: 2.30375704,
        date: "2026-07-22T07:50:54.000Z",
      },
      {
        lat: 48.87070065,
        lon: 2.30415426,
        date: "2026-07-22T07:50:57.000Z",
      },
      {
        lat: 48.87058031,
        lon: 2.3045173,
        date: "2026-07-22T07:51:00.000Z",
      },
      {
        lat: 48.87046043,
        lon: 2.30487672,
        date: "2026-07-22T07:51:03.000Z",
      },
      {
        lat: 48.87034027,
        lon: 2.30526745,
        date: "2026-07-22T07:51:06.000Z",
      },
      {
        lat: 48.87021912,
        lon: 2.3056869,
        date: "2026-07-22T07:51:09.000Z",
      },
      {
        lat: 48.87009638,
        lon: 2.30609808,
        date: "2026-07-22T07:51:12.000Z",
      },
      {
        lat: 48.86997153,
        lon: 2.30647392,
        date: "2026-07-22T07:51:15.000Z",
      },
      {
        lat: 48.86984428,
        lon: 2.30682967,
        date: "2026-07-22T07:51:18.000Z",
      },
      {
        lat: 48.86971452,
        lon: 2.30720463,
        date: "2026-07-22T07:51:21.000Z",
      },
      {
        lat: 48.86958233,
        lon: 2.30761511,
        date: "2026-07-22T07:51:24.000Z",
      },
      {
        lat: 48.86944803,
        lon: 2.30803487,
        date: "2026-07-22T07:51:27.000Z",
      },
      {
        lat: 48.86931209,
        lon: 2.30842655,
        date: "2026-07-22T07:51:30.000Z",
      },
      {
        lat: 48.86916375,
        lon: 2.30859809,
        date: "2026-07-22T07:51:33.000Z",
      },
      {
        lat: 48.86901696,
        lon: 2.30877189,
        date: "2026-07-22T07:51:36.000Z",
      },
      {
        lat: 48.86887669,
        lon: 2.30897897,
        date: "2026-07-22T07:51:39.000Z",
      },
      {
        lat: 48.86874581,
        lon: 2.30921095,
        date: "2026-07-22T07:51:42.000Z",
      },
      {
        lat: 48.86862413,
        lon: 2.30942997,
        date: "2026-07-22T07:51:45.000Z",
      },
      {
        lat: 48.8685085,
        lon: 2.30961351,
        date: "2026-07-22T07:51:48.000Z",
      },
      {
        lat: 48.86839382,
        lon: 2.30978106,
        date: "2026-07-22T07:51:51.000Z",
      },
      {
        lat: 48.86827467,
        lon: 2.30997103,
        date: "2026-07-22T07:51:54.000Z",
      },
      {
        lat: 48.86814709,
        lon: 2.3101953,
        date: "2026-07-22T07:51:57.000Z",
      },
      {
        lat: 48.86800982,
        lon: 2.31042513,
        date: "2026-07-22T07:52:00.000Z",
      },
      {
        lat: 48.86786476,
        lon: 2.31062521,
        date: "2026-07-22T07:52:03.000Z",
      },
      {
        lat: 48.86771632,
        lon: 2.31079545,
        date: "2026-07-22T07:52:06.000Z",
      },
      {
        lat: 48.86756999,
        lon: 2.31097107,
        date: "2026-07-22T07:52:09.000Z",
      },
      {
        lat: 48.86743059,
        lon: 2.31118094,
        date: "2026-07-22T07:52:12.000Z",
      },
      {
        lat: 48.86730069,
        lon: 2.31141337,
        date: "2026-07-22T07:52:15.000Z",
      },
      {
        lat: 48.86717981,
        lon: 2.31162997,
        date: "2026-07-22T07:52:18.000Z",
      },
      {
        lat: 48.86706453,
        lon: 2.31181109,
        date: "2026-07-22T07:52:21.000Z",
      },
      {
        lat: 48.86694963,
        lon: 2.31197908,
        date: "2026-07-22T07:52:24.000Z",
      },
      {
        lat: 48.86682977,
        lon: 2.31217183,
        date: "2026-07-22T07:52:27.000Z",
      },
      {
        lat: 48.86670122,
        lon: 2.31239794,
        date: "2026-07-22T07:52:30.000Z",
      },
      {
        lat: 48.86656303,
        lon: 2.31262648,
        date: "2026-07-22T07:52:33.000Z",
      },
      {
        lat: 48.8664174,
        lon: 2.31282368,
        date: "2026-07-22T07:52:36.000Z",
      },
      {
        lat: 48.86626891,
        lon: 2.31299284,
        date: "2026-07-22T07:52:39.000Z",
      },
      {
        lat: 48.86612309,
        lon: 2.31317048,
        date: "2026-07-22T07:52:42.000Z",
      },
      {
        lat: 48.86598458,
        lon: 2.31338307,
        date: "2026-07-22T07:52:45.000Z",
      },
      {
        lat: 48.86585567,
        lon: 2.3136157,
        date: "2026-07-22T07:52:48.000Z",
      },
      {
        lat: 48.86573555,
        lon: 2.31382975,
        date: "2026-07-22T07:52:51.000Z",
      },
      {
        lat: 48.86562056,
        lon: 2.31400858,
        date: "2026-07-22T07:52:54.000Z",
      },
      {
        lat: 48.86550539,
        lon: 2.31417726,
        date: "2026-07-22T07:52:57.000Z",
      },
      {
        lat: 48.86538478,
        lon: 2.31437286,
        date: "2026-07-22T07:53:00.000Z",
      },
      {
        lat: 48.86525524,
        lon: 2.31460059,
        date: "2026-07-22T07:53:03.000Z",
      },
      {
        lat: 48.86511616,
        lon: 2.31482762,
        date: "2026-07-22T07:53:06.000Z",
      },
      {
        lat: 48.86497,
        lon: 2.31502196,
        date: "2026-07-22T07:53:09.000Z",
      },
      {
        lat: 48.86482154,
        lon: 2.3151903,
        date: "2026-07-22T07:53:12.000Z",
      },
      {
        lat: 48.86467627,
        lon: 2.31537012,
        date: "2026-07-22T07:53:15.000Z",
      },
      {
        lat: 48.86459612,
        lon: 2.31532707,
        date: "2026-07-22T07:53:18.000Z",
      },
      {
        lat: 48.86450333,
        lon: 2.3153004,
        date: "2026-07-22T07:53:21.000Z",
      },
      {
        lat: 48.86437043,
        lon: 2.31526783,
        date: "2026-07-22T07:53:24.000Z",
      },
      {
        lat: 48.86422358,
        lon: 2.31521197,
        date: "2026-07-22T07:53:27.000Z",
      },
      {
        lat: 48.86410761,
        lon: 2.31513496,
        date: "2026-07-22T07:53:30.000Z",
      },
      {
        lat: 48.86402603,
        lon: 2.31505658,
        date: "2026-07-22T07:53:33.000Z",
      },
      {
        lat: 48.86393639,
        lon: 2.31499779,
        date: "2026-07-22T07:53:36.000Z",
      },
      {
        lat: 48.863807,
        lon: 2.31496316,
        date: "2026-07-22T07:53:39.000Z",
      },
      {
        lat: 48.86365933,
        lon: 2.31493703,
        date: "2026-07-22T07:53:42.000Z",
      },
      {
        lat: 48.8635393,
        lon: 2.31489666,
        date: "2026-07-22T07:53:45.000Z",
      },
      {
        lat: 48.86345587,
        lon: 2.3148312,
        date: "2026-07-22T07:53:48.000Z",
      },
      {
        lat: 48.86336904,
        lon: 2.3147508,
        date: "2026-07-22T07:53:51.000Z",
      },
      {
        lat: 48.86324338,
        lon: 2.31467809,
        date: "2026-07-22T07:53:54.000Z",
      },
      {
        lat: 48.86309537,
        lon: 2.31462928,
        date: "2026-07-22T07:53:57.000Z",
      },
      {
        lat: 48.86297138,
        lon: 2.31460059,
        date: "2026-07-22T07:54:00.000Z",
      },
      {
        lat: 48.86288566,
        lon: 2.3145714,
        date: "2026-07-22T07:54:03.000Z",
      },
      {
        lat: 48.86280129,
        lon: 2.31452153,
        date: "2026-07-22T07:54:06.000Z",
      },
      {
        lat: 48.86267953,
        lon: 2.31444807,
        date: "2026-07-22T07:54:09.000Z",
      },
      {
        lat: 48.86253165,
        lon: 2.31436786,
        date: "2026-07-22T07:54:12.000Z",
      },
      {
        lat: 48.86240385,
        lon: 2.31430338,
        date: "2026-07-22T07:54:15.000Z",
      },
      {
        lat: 48.86231547,
        lon: 2.31426395,
        date: "2026-07-22T07:54:18.000Z",
      },
      {
        lat: 48.86223315,
        lon: 2.31423795,
        date: "2026-07-22T07:54:21.000Z",
      },
      {
        lat: 48.86211541,
        lon: 2.31420251,
        date: "2026-07-22T07:54:24.000Z",
      },
      {
        lat: 48.86196815,
        lon: 2.31414267,
        date: "2026-07-22T07:54:27.000Z",
      },
      {
        lat: 48.86183674,
        lon: 2.31406387,
        date: "2026-07-22T07:54:30.000Z",
      },
      {
        lat: 48.86174535,
        lon: 2.31398741,
        date: "2026-07-22T07:54:33.000Z",
      },
      {
        lat: 48.86166464,
        lon: 2.31393264,
        date: "2026-07-22T07:54:36.000Z",
      },
      {
        lat: 48.86155098,
        lon: 2.31390075,
        date: "2026-07-22T07:54:39.000Z",
      },
      {
        lat: 48.86140481,
        lon: 2.31387381,
        date: "2026-07-22T07:54:42.000Z",
      },
      {
        lat: 48.86127004,
        lon: 2.31382975,
        date: "2026-07-22T07:54:45.000Z",
      },
      {
        lat: 48.86114344,
        lon: 2.31368029,
        date: "2026-07-22T07:54:48.000Z",
      },
      {
        lat: 48.86102175,
        lon: 2.3135123,
        date: "2026-07-22T07:54:51.000Z",
      },
      {
        lat: 48.86090345,
        lon: 2.31336001,
        date: "2026-07-22T07:54:54.000Z",
      },
      {
        lat: 48.86078635,
        lon: 2.31324052,
        date: "2026-07-22T07:54:57.000Z",
      },
      {
        lat: 48.86066809,
        lon: 2.31313503,
        date: "2026-07-22T07:55:00.000Z",
      },
      {
        lat: 48.86054647,
        lon: 2.31300947,
        date: "2026-07-22T07:55:03.000Z",
      },
      {
        lat: 48.86041995,
        lon: 2.31285169,
        date: "2026-07-22T07:55:06.000Z",
      },
      {
        lat: 48.86028789,
        lon: 2.31268477,
        date: "2026-07-22T07:55:09.000Z",
      },
      {
        lat: 48.86015067,
        lon: 2.31254179,
        date: "2026-07-22T07:55:12.000Z",
      },
      {
        lat: 48.86000962,
        lon: 2.31242966,
        date: "2026-07-22T07:55:15.000Z",
      },
      {
        lat: 48.85986679,
        lon: 2.31232154,
        date: "2026-07-22T07:55:18.000Z",
      },
      {
        lat: 48.85972455,
        lon: 2.31218623,
        date: "2026-07-22T07:55:21.000Z",
      },
      {
        lat: 48.85958518,
        lon: 2.31202224,
        date: "2026-07-22T07:55:24.000Z",
      },
      {
        lat: 48.8594504,
        lon: 2.31185945,
        date: "2026-07-22T07:55:27.000Z",
      },
      {
        lat: 48.85932109,
        lon: 2.31172641,
        date: "2026-07-22T07:55:30.000Z",
      },
      {
        lat: 48.85919714,
        lon: 2.31161917,
        date: "2026-07-22T07:55:33.000Z",
      },
      {
        lat: 48.85907742,
        lon: 2.31150554,
        date: "2026-07-22T07:55:36.000Z",
      },
      {
        lat: 48.85896003,
        lon: 2.31136035,
        date: "2026-07-22T07:55:39.000Z",
      },
      {
        lat: 48.85884263,
        lon: 2.31119291,
        date: "2026-07-22T07:55:42.000Z",
      },
      {
        lat: 48.8587229,
        lon: 2.31103687,
        date: "2026-07-22T07:55:45.000Z",
      },
      {
        lat: 48.85859892,
        lon: 2.31091341,
        date: "2026-07-22T07:55:48.000Z",
      },
      {
        lat: 48.85846959,
        lon: 2.31080809,
        date: "2026-07-22T07:55:51.000Z",
      },
      {
        lat: 48.85833479,
        lon: 2.31068664,
        date: "2026-07-22T07:55:54.000Z",
      },
      {
        lat: 48.85819539,
        lon: 2.31053242,
        date: "2026-07-22T07:55:57.000Z",
      },
      {
        lat: 48.85805315,
        lon: 2.31036462,
        date: "2026-07-22T07:56:00.000Z",
      },
      {
        lat: 48.85791032,
        lon: 2.31021728,
        date: "2026-07-22T07:56:03.000Z",
      },
      {
        lat: 48.85776929,
        lon: 2.31010207,
        date: "2026-07-22T07:56:06.000Z",
      },
      {
        lat: 48.85763209,
        lon: 2.30999553,
        date: "2026-07-22T07:56:09.000Z",
      },
      {
        lat: 48.85750005,
        lon: 2.30986472,
        date: "2026-07-22T07:56:12.000Z",
      },
      {
        lat: 48.85737356,
        lon: 2.30970324,
        date: "2026-07-22T07:56:15.000Z",
      },
    ],
  },
];

export const fakeTripsByDayListForDemo: Trips[] = [
  // Geoloc 1 is driven by two drivers on the same day: the API returns one group
  // per driver, so each trip of the trace must show its own driver
  {
    vehicleUuid: "e66252a8-a353-4096-a592-88b0dc3998bc",
    date: "2026-07-22",
    count: 1,
    registrationNumber: "GE-123-OL",
    reference: "Geoloc 1",
    usageStartDate: "2026-07-22T08:15:00.000Z",
    usageEndDate: "2026-07-22T08:21:00.000Z",
    totalDistanceInKm: 1.6,
    hoursDuration: 0.1,
    driver: {
      lastName: "Doe",
      firstName: "John",
      analyticCode1: null,
      uuid: "fake-driver-uuid-001",
    },
    trips: [
      {
        uuid: "d37f1824-3564-4d91-8b5d-8cc2c1ae543c",
        secondsDuration: 360,
        distance: 1.6,
        startDate: "2026-07-22T08:15:00.000Z",
        endDate: "2026-07-22T08:21:00.000Z",
        ecoDrivingScore: 72.4,
        smoothnessScore: null,
        harshAccelerationsCount: null,
        harshBrakesCount: null,
        sharpTurnsCount: null,
        departureAddress: "18 Rue de Clignancourt, 75018 Paris, France",
        destinationAddress: "8 Place de l'Hôtel de Ville, 75004 Paris, France",
      },
    ],
    vehicleModel: "CLIO",
    vehicleType: "SHARED",
    vehicleAnalyticCode: null,
  },
  {
    vehicleUuid: "e66252a8-a353-4096-a592-88b0dc3998bc",
    date: "2026-07-22",
    count: 1,
    registrationNumber: "GE-123-OL",
    reference: "Geoloc 1",
    usageStartDate: "2026-07-22T08:21:30.000Z",
    usageEndDate: "2026-07-22T08:27:00.000Z",
    totalDistanceInKm: 1.3,
    hoursDuration: 0.09,
    driver: {
      lastName: "Martin",
      firstName: "Claire",
      analyticCode1: null,
      uuid: "fake-driver-uuid-004",
    },
    trips: [
      {
        uuid: "477b49c3-4fb5-4543-8491-b777c86c1ec3",
        secondsDuration: 330,
        distance: 1.3,
        startDate: "2026-07-22T08:21:30.000Z",
        endDate: "2026-07-22T08:27:00.000Z",
        ecoDrivingScore: null,
        smoothnessScore: null,
        harshAccelerationsCount: null,
        harshBrakesCount: null,
        sharpTurnsCount: null,
        departureAddress: "8 Place de l'Hôtel de Ville, 75004 Paris, France",
        destinationAddress: "3 Rue du Départ, 75014 Paris, France",
      },
    ],
    vehicleModel: "CLIO",
    vehicleType: "SHARED",
    vehicleAnalyticCode: null,
  },
  {
    vehicleUuid: "e66252a8-a353-4096-a592-88b0dc399803",
    date: "2026-07-22",
    count: 2,
    registrationNumber: "AA-123-ZZ",
    reference: "Geoloc 5",
    usageStartDate: "2026-07-22T07:45:00.000Z",
    usageEndDate: "2026-07-22T07:56:15.000Z",
    totalDistanceInKm: 2.8,
    hoursDuration: 0.19,
    driver: {
      lastName: "Legrand",
      firstName: "Jean",
      analyticCode1: null,
      uuid: "fake-driver-uuid-002",
    },
    trips: [
      {
        uuid: "850ae188-a6ae-4f99-8d75-57b0af77d7d2",
        secondsDuration: 300,
        distance: 1.4,
        startDate: "2026-07-22T07:45:00.000Z",
        endDate: "2026-07-22T07:50:00.000Z",
        ecoDrivingScore: null,
        smoothnessScore: null,
        harshAccelerationsCount: null,
        harshBrakesCount: null,
        sharpTurnsCount: null,
        departureAddress:
          "14 Boulevard de la République, 92250 La Garenne-Colombes, France",
        destinationAddress: "2 Avenue de la Grande Armée, 75017 Paris, France",
      },
      {
        uuid: "da4c3119-d948-4982-9e25-06d6ad2d290d",
        secondsDuration: 375,
        distance: 1.4,
        startDate: "2026-07-22T07:51:00.000Z",
        endDate: "2026-07-22T07:56:15.000Z",
        ecoDrivingScore: null,
        smoothnessScore: null,
        harshAccelerationsCount: null,
        harshBrakesCount: null,
        sharpTurnsCount: null,
        departureAddress: "2 Avenue de la Grande Armée, 75017 Paris, France",
        destinationAddress: "21 Avenue de Suffren, 75015 Paris, France",
      },
    ],
    vehicleModel: "CLIO",
    vehicleType: "SHARED",
    vehicleAnalyticCode: null,
  },
  {
    vehicleUuid: "e66252a8-a353-4096-a592-88b0dc399800",
    date: "2025-06-10",
    count: 1,
    registrationNumber: "OC-444-AL",
    reference: "Geoloc 2",
    usageStartDate: "2025-06-10T10:13:46.000Z",
    usageEndDate: "2025-06-10T10:27:04.000Z",
    totalDistanceInKm: 4.2,
    hoursDuration: 0.22,
    driver: {
      lastName: "Smith",
      firstName: "John",
      analyticCode1: null,
      uuid: "fake-driver-uuid-003",
    },
    trips: [
      {
        uuid: "4c325c13-d4dc-403d-ba5d-25c186ffba38",
        secondsDuration: 798,
        distance: 4.2,
        startDate: "2025-06-10T10:13:46.000Z",
        endDate: "2025-06-10T10:27:04.000Z",
        ecoDrivingScore: null,
        smoothnessScore: null,
        harshAccelerationsCount: null,
        harshBrakesCount: null,
        sharpTurnsCount: null,
        departureAddress: "22 Avenue de Paris, 94160 Saint-Mandé, France",
        destinationAddress: "5 Rue de Paris, 94220 Charenton-le-Pont, France",
      },
    ],
    vehicleModel: "DS",
    vehicleType: "SHARED",
    vehicleAnalyticCode: null,
  },
];

// Véhicule 0 (GE-123-OL) : one-way (Montmartre → Montparnasse).
// Aller-retour désactivé (utile pour tester le z-index voiture/jonction) — décommenter pour le réactiver.
// const _v1Fwd = [...fakeVehicleGeolocatedForDemo[0].dataPoints];
// const _v1ReturnStart = new Date("2026-07-22T08:28:30.000Z").getTime();
// fakeVehicleGeolocatedForDemo[0].dataPoints = [
//   ..._v1Fwd,
//   ..._v1Fwd
//     .slice()
//     .reverse()
//     .map((dp, i) => ({
//       lat: dp.lat,
//       lon: dp.lon,
//       date: new Date(_v1ReturnStart + i * 3000).toISOString(),
//     })),
// ];
// fakeVehicleGeolocatedForDemo[0].lastLatitude = _v1Fwd[0].lat;
// fakeVehicleGeolocatedForDemo[0].lastLongitude = _v1Fwd[0].lon;
// fakeTripsByDayListForDemo[0].count = 3;
// fakeTripsByDayListForDemo[0].trips.push({
//   secondsDuration: _v1Fwd.length * 3,
//   distance: 3.2,
//   startDate: "2026-07-22T08:28:30.000Z",
//   endDate: new Date(_v1ReturnStart + (_v1Fwd.length - 2) * 3000).toISOString(),
//   ecoDrivingScore: 85.6,
//   smoothnessScore: null,
//   harshAccelerationsCount: null,
//   harshBrakesCount: null,
//   sharpTurnsCount: null,
// });

// Véhicule 1 (OC-444-AL) : 4 trajets terminés (A→B→A→B→A) → jonction exactement sur le vert/rouge
const _v2Fwd = [...fakeVehicleGeolocatedForDemo[1].dataPoints];
const _N2 = _v2Fwd.length;
const _v2ReturnStart = new Date("2025-06-10T10:28:00.000Z").getTime();
const _v2Fwd2Start = _v2ReturnStart + (_N2 + 30) * 3000;
const _v2Return2Start = _v2Fwd2Start + (_N2 + 30) * 3000;
fakeVehicleGeolocatedForDemo[1].dataPoints = [
  ..._v2Fwd,
  ..._v2Fwd
    .slice()
    .reverse()
    .map((dp, i) => ({
      lat: dp.lat,
      lon: dp.lon,
      date: new Date(_v2ReturnStart + i * 3000).toISOString(),
    })),
  ..._v2Fwd.map((dp, i) => ({
    lat: dp.lat,
    lon: dp.lon,
    date: new Date(_v2Fwd2Start + i * 3000).toISOString(),
  })),
  ..._v2Fwd
    .slice()
    .reverse()
    .map((dp, i) => ({
      lat: dp.lat,
      lon: dp.lon,
      date: new Date(_v2Return2Start + i * 3000).toISOString(),
    })),
];
fakeVehicleGeolocatedForDemo[1].lastLatitude = _v2Fwd[0].lat;
fakeVehicleGeolocatedForDemo[1].lastLongitude = _v2Fwd[0].lon;
fakeTripsByDayListForDemo[2].count = 4;
fakeTripsByDayListForDemo[2].trips = [
  {
    uuid: "1fadbb42-e2ef-45b3-bfb8-d8c70199a6ed",
    secondsDuration: _N2 * 3,
    distance: 4.2,
    startDate: _v2Fwd[0].date,
    endDate: _v2Fwd[_N2 - 1].date,
    ecoDrivingScore: null,
    smoothnessScore: null,
    harshAccelerationsCount: null,
    harshBrakesCount: null,
    sharpTurnsCount: null,
    departureAddress: "22 Avenue de Paris, 94160 Saint-Mandé, France",
    destinationAddress: "5 Rue de Paris, 94220 Charenton-le-Pont, France",
  },
  {
    uuid: "3f1ec9db-a637-45d7-88b8-104d0f266a02",
    secondsDuration: _N2 * 3,
    distance: 4.2,
    startDate: new Date(_v2ReturnStart).toISOString(),
    endDate: new Date(_v2ReturnStart + (_N2 - 1) * 3000).toISOString(),
    ecoDrivingScore: null,
    smoothnessScore: null,
    harshAccelerationsCount: null,
    harshBrakesCount: null,
    sharpTurnsCount: null,
    departureAddress: "5 Rue de Paris, 94220 Charenton-le-Pont, France",
    destinationAddress: "22 Avenue de Paris, 94160 Saint-Mandé, France",
  },
  {
    uuid: "3513786b-4d83-4dfb-bf9c-40dac1b7c216",
    secondsDuration: _N2 * 3,
    distance: 4.2,
    startDate: new Date(_v2Fwd2Start).toISOString(),
    endDate: new Date(_v2Fwd2Start + (_N2 - 1) * 3000).toISOString(),
    ecoDrivingScore: null,
    smoothnessScore: null,
    harshAccelerationsCount: null,
    harshBrakesCount: null,
    sharpTurnsCount: null,
    departureAddress: "22 Avenue de Paris, 94160 Saint-Mandé, France",
    destinationAddress: "5 Rue de Paris, 94220 Charenton-le-Pont, France",
  },
  {
    uuid: "f41a2988-1214-46f0-a0ed-b38eff24c46e",
    secondsDuration: _N2 * 3,
    distance: 4.2,
    startDate: new Date(_v2Return2Start).toISOString(),
    endDate: new Date(_v2Return2Start + (_N2 - 1) * 3000).toISOString(),
    ecoDrivingScore: 85.6,
    smoothnessScore: null,
    harshAccelerationsCount: null,
    harshBrakesCount: null,
    sharpTurnsCount: null,
    departureAddress: "5 Rue de Paris, 94220 Charenton-le-Pont, France",
    destinationAddress: "22 Avenue de Paris, 94160 Saint-Mandé, France",
  },
];
